/*
  Extracted from snippets/params-foodify.liquid, which inlined this into
  every cart, collection, product and search page. Inline script is never
  cached and never shared across navigations; this file is both.
  Liquid values arrive via window.FOODIFY_CONFIG.
*/

var CFG = window.FOODIFY_CONFIG || {};

console.log('[ FOODIFY - v11 ]');
console.log("---------------")

// Page-type helpers. Matching '/collections' anywhere in the href treats a
// collection-scoped product URL (/collections/x/products/y) as a listing page,
// which routes the product branch into the card-grid branch and breaks the PDP.
function isProductDetailPage() {
  return window.location.pathname.includes('/products/');
}

function isCollectionListingPage() {
  const path = window.location.pathname;
  return !isProductDetailPage() && (path.includes('/collections') || path.includes('/search'));
}

window.waitForElmFoodify = (selector) =>
  new Promise((resolve) => {
    const resolveIfFound = () => {
      const element = document.querySelector(selector);
      if (element) {
        observer.disconnect();
        resolve(element);
      }
    };

    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      resolveIfFound();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });

class Timer {
  constructor() {
    this.timers = {};
  }

  start(name) {
    if (!this.timers[name]) {
      this.timers[name] = { start: performance.now(), elapsed: 0 };
    }
  }

  stop(name) {
    if (this.timers[name]) {
      const elapsed = performance.now() - this.timers[name].start;
      this.timers[name].elapsed = elapsed;
      const seconds = (elapsed / 1000).toFixed(2);
      const ms = elapsed.toFixed(3);
    //-console.log(`${name}: ${seconds}s (${ms}ms)`);
      delete this.timers[name];
    }
  }
}

const timer = new Timer();
timer.start('INSERT');



var scriptSrc = CFG.microModalSrc;
if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
    var script = document.createElement('script');
    script.src = scriptSrc;
    script.defer = true;
    document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', function () {
  // MicroModal.init binds a listener per trigger, so running it twice would open
  // every modal twice.
  if (window.__foodifyModalInit) return;
  window.__foodifyModalInit = true;

  waitForElmFoodify(`.button[data-custom-open]`).then(() => {
      MicroModal.init({
          // onShow: modal => console.info(`${modal.id} is shown`),
          // onClose: modal => console.info(`${modal.id} is hidden`),
          openTrigger: 'data-custom-open',
          closeTrigger: 'data-micromodal-close',
          openClass: 'is-open',
          disableScroll: true,
          disableFocus: false,
          awaitOpenAnimation: false,
          awaitCloseAnimation: false,
          debugMode: true
      });

      // MicroModal.init binds a click listener directly to every trigger present
      // at this moment. Mark those as wired so the delegated fallback below skips
      // them — otherwise both would fire and the modal would open twice.
      document.querySelectorAll('[data-custom-open]').forEach((trigger) => {
        trigger.setAttribute('data-foodify-wired', 'true');
      });
  });
});

// Triggers are server-rendered now, and grids grow after init (infinite scroll,
// facet swaps), so a shopper can click a trigger MicroModal never saw. This
// delegated listener covers exactly those.
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-custom-open]');
  if (!trigger || trigger.hasAttribute('data-foodify-wired')) return;

  const modalId = trigger.getAttribute('data-custom-open');
  if (!modalId || !document.getElementById(modalId)) return;

  event.preventDefault();
  try { MicroModal.show(modalId); } catch (err) { console.error(err); }
});
  


  //////////////////////////////////////////////////////////
  if (CFG.customerLoggedIn) window.customerLoggedIn = true;
  const enableTestMode = false;
  const normal_bg_color = CFG.normalBgColor;
  const highlight_bg_color = CFG.highlightBgColor;
  const normal_text_color = CFG.normalTextColor;
  const highlight_text_color = CFG.highlightTextColor;
  const useArrow = CFG.useArrow;
  const requireLoginFoodify = CFG.requireLoginFoodify;
  //////////////////////////////////////////////////////////

  

  function parseFoodifyOptions(jsonStr) {
    if (!jsonStr || jsonStr === '' || jsonStr === 'null') return null;
    try {
      return typeof jsonStr === 'object' ? jsonStr : JSON.parse(jsonStr);
    } catch(e) {
      console.error('Foodify: Failed to parse options JSON', e);
      return null;
    }
  }

  if (enableTestMode) {
   const storeData = [
      {
          "__typename": "Store",
          "createdAt": "2024-02-14T16:47:26.830Z",
          "id": "3",
          "sandwiches": [
              {
                  "id": "6998201925710",
                  "title": "Atlantic Salmon Fillet",
                  "options": {
                      "Fillet Options": {
                          "type": "checkbox",
                          "items": [
                              {
                                  "cost": "0",
                                  "name": "Middle",
                                  "optionId": "new_Fillet Options_1707936186880_504",
                                  "index": "4",
                                  "additionalCost": "0.75"
                              },
                              {
                                  "cost": "0",
                                  "name": "Near Head",
                                  "optionId": "new_Fillet Options_1707936187542_811",
                                  "index": "3",
                                  "additionalCost": "1.75"
                              },
                              {
                                  "cost": "0",
                                  "name": "Next To Tail",
                                  "optionId": "new_Fillet Options_1707936188296_19",
                                  "index": "2",
                                  "additionalCost": "2.75"
                              },
                              {
                                  "cost": "0",
                                  "name": "Fatty",
                                  "optionId": "new_Fillet Options_1707936190638_403",
                                  "index": "0",
                                  "additionalCost": "3.75"
                              },
                              {
                                  "cost": "0",
                                  "name": "Not Fatty",
                                  "optionId": "new_Fillet Options_1707936193026_812",
                                  "index": "1",
                                  "additionalCost": "4.75"
                              },
                              {
                                  "cost": "0",
                                  "name": "Trim Fat",
                                  "optionId": "new_Fillet Options_1707936193696_65",
                                  "additionalCost": "5.75"
                              },
                              {
                                  "cost": "0",
                                  "name": "Wide ",
                                  "optionId": "new_Fillet Options_1707936194966_469",
                                  "additionalCost": "6.75"
                              },
                              {
                                  "cost": "0",
                                  "name": "Cut in Half Width ",
                                  "optionId": "new_Fillet Options_1707936195658_917",
                                  "additionalCost": "7.75"
                              },
                              {
                                  "cost": "0",
                                  "name": "Cut in Half Length ",
                                  "optionId": "new_Fillet Options_1707936196275_508",
                                  "additionalCost": "8.75"
                              },
                              {
                                  "cost": "0",
                                  "name": "Salt the Fish",
                                  "optionId": "new_Fillet Options_1707936196944_433",
                                  "additionalCost": "9.75"
                              },
                              {
                                  "type": "rule",
                                  "action": "hide",
                                  "ruleId": "new_Fillet Options_1708623843654_490",
                                  "ruleFields": [
                                      {
                                          "name": "Near Head",
                                          "optionId": "new_Fillet Options_1707936187542_811"
                                      },
                                      {
                                          "name": "Next To Tail",
                                          "optionId": "new_Fillet Options_1707936188296_19"
                                      }
                                  ],
                                  "conditionLink": "equal",
                                  "firstCondition": "current-selection",
                                  "secondCondition": "Middle"
                              },
                              {
                                  "type": "rule",
                                  "action": "hide",
                                  "ruleId": "new_Fillet Options_1710099393432_213",
                                  "ruleFields": [
                                      {
                                          "name": "Middle",
                                          "optionId": "new_Fillet Options_1707936186880_504"
                                      },
                                      {
                                          "name": "Next To Tail",
                                          "optionId": "new_Fillet Options_1707936188296_19"
                                      }
                                  ],
                                  "conditionLink": "equal",
                                  "firstCondition": "current-selection",
                                  "secondCondition": "Near Head"
                              },
                              {
                                  "type": "rule",
                                  "action": "hide",
                                  "ruleId": "new_Fillet Options_1710099409797_211",
                                  "ruleFields": [
                                      {
                                          "name": "Middle",
                                          "optionId": "new_Fillet Options_1707936186880_504"
                                      },
                                      {
                                          "name": "Near Head",
                                          "optionId": "new_Fillet Options_1707936187542_811"
                                      }
                                  ],
                                  "conditionLink": "equal",
                                  "firstCondition": "current-selection",
                                  "secondCondition": "Next To Tail"
                              },
                              {
                                  "type": "rule",
                                  "action": "hide",
                                  "ruleId": "new_Fillet Options_1710099427887_541",
                                  "ruleFields": [
                                      {
                                          "name": "Not Fatty",
                                          "optionId": "new_Fillet Options_1707936193026_812"
                                      },
                                      {
                                          "name": "Trim Fat",
                                          "optionId": "new_Fillet Options_1707936193696_65"
                                      }
                                  ],
                                  "conditionLink": "equal",
                                  "firstCondition": "current-selection",
                                  "secondCondition": "Fatty"
                              },
                              {
                                  "type": "rule",
                                  "action": "hide",
                                  "ruleId": "new_Fillet Options_1710099443114_973",
                                  "ruleFields": [
                                      {
                                          "name": "Fatty",
                                          "optionId": "new_Fillet Options_1707936190638_403"
                                      }
                                  ],
                                  "conditionLink": "equal",
                                  "firstCondition": "current-selection",
                                  "secondCondition": "Not Fatty"
                              }
                          ],
                          "hardLimit": true,
                          "hardLimitNumber": "5",
                          "optionLimit": "2",
                      },
                      "Onions": {
                          "type": "pill",
                          "items": [
                              {
                                  "cost": "0",
                                  "name": "Yes Onions ",
                                  "optionId": "new_Onions_1707937375284_136",
                                  "index": "4"
                              },
                              {
                                  "cost": "0",
                                  "name": "No Onions",
                                  "optionId": "new_Onions_1707937383820_385",
                                  "index": "1"
                              }
                          ],
                          "helpText": "",
                          "required": true,
                          "selectionMessage": "Please Select Onions"
                      },
                      "Select Side Dish": {
                          "id": "new__1708028056719_988",
                          "type": "radio",
                          "items": [
                              {
                                  "cost": "0",
                                  "name": "Chinese Rice",
                                  "optionId": "new_Side Dishes_1708028150380_817",
                                  "index": "4"
                              },
                              {
                                  "cost": "0",
                                  "name": "Brown Rice",
                                  "optionId": "new_Side Dishes_1708028171298_897"
                              },
                              {
                                  "cost": "0",
                                  "name": "Spanish Rice",
                                  "optionId": "new_Side Dishes_1708028180514_399",
                                  "index": "0"
                              },
                              {
                                  "cost": "0",
                                  "name": "Sushi Rice",
                                  "optionId": "new_Side Dishes_1708028190505_420"
                              },
                              {
                                  "cost": "1",
                                  "name": "Grilled Vegetables",
                                  "optionId": "new_Side Dishes_1708028198837_855",
                                  "index": "1"
                              },
                              {
                                  "cost": "1",
                                  "name": "Stir Fry Vegetables",
                                  "optionId": "new_Side Dishes_1708028210821_598"
                              },
                              {
                                  "cost": "1",
                                  "name": "Roasted Root Vegetables",
                                  "optionId": "new_Side Dishes_1708028229930_169",
                                  "index": "2"
                              },
                              {
                                  "cost": "1",
                                  "name": "Crispy Cauliflower",
                                  "optionId": "new_Side Dishes_1708028242258_514",
                                  "index": "3"
                              },
                              {
                                  "cost": "1",
                                  "name": "String Beans",
                                  "optionId": "new_Side Dishes_1708028286943_464"
                              },
                              {
                                  "cost": "1",
                                  "name": "Seasoned Broccoli",
                                  "optionId": "new_Side Dishes_1708028318043_539"
                              },
                              {
                                  "cost": "1",
                                  "name": "Plain Steamed Broccoli",
                                  "optionId": "new_Side Dishes_1708028331107_468"
                              },
                              {
                                  "cost": "1",
                                  "name": "Zucchini In Tomato Sauce",
                                  "optionId": "new_Side Dishes_1708028348456_317"
                              },
                              {
                                  "cost": "1",
                                  "name": "Letcho",
                                  "optionId": "new_Side Dishes_1708028373164_652"
                              },
                              {
                                  "cost": "1",
                                  "name": "Mashed Potatoes",
                                  "optionId": "new_Side Dishes_1708028379165_755"
                              },
                              {
                                  "cost": "1",
                                  "name": "Sweet Potato",
                                  "optionId": "new_Side Dishes_1708028394368_284"
                              },
                              {
                                  "cost": "1",
                                  "name": "Roasted Potatoes",
                                  "optionId": "new_Side Dishes_1708028410217_564"
                              },
                              {
                                  "cost": "1",
                                  "name": "Cabbage & Noodles",
                                  "optionId": "new_Side Dishes_1708028432797_270"
                              },
                              {
                                  "cost": "1",
                                  "name": "Shlishkes",
                                  "optionId": "new_Side Dishes_1708028464083_408"
                              },
                              {
                                  "cost": "1",
                                  "name": "French Fries",
                                  "optionId": "new_Side Dishes_1708028526156_693"
                              },
                              {
                                  "cost": "1",
                                  "name": "Spicy Fries",
                                  "optionId": "new_Side Dishes_1708028540352_192"
                              },
                              {
                                  "cost": "1",
                                  "name": "Mixed Fries",
                                  "optionId": "new_Side Dishes_1708028549439_725"
                              },
                              {
                                  "cost": "2",
                                  "name": "Sweet Potato Fries",
                                  "optionId": "new_Side Dishes_1708028559272_592"
                              },
                              {
                                  "cost": "1",
                                  "name": "Broccoli Salad",
                                  "optionId": "new_Side Dishes_1708028574415_694"
                              },
                              {
                                  "cost": "1",
                                  "name": "Diet Broccoli Salad",
                                  "optionId": "new_Side Dishes_1708028589084_380"
                              },
                              {
                                  "cost": "1",
                                  "name": "Coleslaw",
                                  "optionId": "new_Side Dishes_1708028607089_449"
                              },
                              {
                                  "cost": "1",
                                  "name": "Diet Coleslaw",
                                  "optionId": "new_Side Dishes_1708028628084_416"
                              },
                              {
                                  "cost": "1",
                                  "name": "Cucumber Salad",
                                  "optionId": "new_Side Dishes_1708028680874_314"
                              },
                              {
                                  "cost": "1",
                                  "name": "Diet Cucumber Salad",
                                  "optionId": "new_Side Dishes_1708028688790_429"
                              },
                              {
                                  "cost": "1",
                                  "name": "Israeli Salad",
                                  "optionId": "new_Side Dishes_1708028725523_168"
                              },
                              {
                                  "cost": "0",
                                  "name": "No Sides",
                                  "optionId": "new_Side Dishes_1708028755027_95"
                              }
                          ],
                          "sortIndex": "1",
                          "showByDefault": true,
                          "selectionMessage": "Please Select S"
                      },
                      "Side Dishes": {
                          "id": "new__1708028056719_988",
                          "type": "select",
                          "items": [
                              {
                                  "cost": "0",
                                  "name": "Chinese Rice",
                                  "optionId": "new_Side Dishes_1708028150380_817"
                              },
                              {
                                  "cost": "0",
                                  "name": "Brown Rice",
                                  "optionId": "new_Side Dishes_1708028171298_897"
                              },
                              {
                                  "cost": "0",
                                  "name": "Spanish Rice",
                                  "optionId": "new_Side Dishes_1708028180514_399",
                                  "index": "1"
                              },
                              {
                                  "cost": "0",
                                  "name": "Sushi Rice",
                                  "optionId": "new_Side Dishes_1708028190505_420"
                              },
                              {
                                  "cost": "1",
                                  "name": "Grilled Vegetables",
                                  "optionId": "new_Side Dishes_1708028198837_855",
                                  "index": "2"
                              },
                              {
                                  "cost": "1",
                                  "name": "Stir Fry Vegetables",
                                  "optionId": "new_Side Dishes_1708028210821_598"
                              },
                              {
                                  "cost": "1",
                                  "name": "Roasted Root Vegetables",
                                  "optionId": "new_Side Dishes_1708028229930_169"
                              },
                              {
                                  "cost": "1",
                                  "name": "Crispy Cauliflower",
                                  "optionId": "new_Side Dishes_1708028242258_514"
                              },
                              {
                                  "cost": "1",
                                  "name": "String Beans",
                                  "optionId": "new_Side Dishes_1708028286943_464",
                                  "index": "3"
                              },
                              {
                                  "cost": "1",
                                  "name": "Seasoned Broccoli",
                                  "optionId": "new_Side Dishes_1708028318043_539"
                              },
                              {
                                  "cost": "1",
                                  "name": "Plain Steamed Broccoli",
                                  "optionId": "new_Side Dishes_1708028331107_468"
                              },
                              {
                                  "cost": "1",
                                  "name": "Zucchini In Tomato Sauce",
                                  "optionId": "new_Side Dishes_1708028348456_317"
                              },
                              {
                                  "cost": "1",
                                  "name": "Letcho",
                                  "optionId": "new_Side Dishes_1708028373164_652"
                              },
                              {
                                  "cost": "1",
                                  "name": "Mashed Potatoes",
                                  "optionId": "new_Side Dishes_1708028379165_755"
                              },
                              {
                                  "cost": "1",
                                  "name": "Sweet Potato",
                                  "optionId": "new_Side Dishes_1708028394368_284"
                              },
                              {
                                  "cost": "1",
                                  "name": "Roasted Potatoes",
                                  "optionId": "new_Side Dishes_1708028410217_564"
                              },
                              {
                                  "cost": "1",
                                  "name": "Cabbage & Noodles",
                                  "optionId": "new_Side Dishes_1708028432797_270"
                              },
                              {
                                  "cost": "1",
                                  "name": "Shlishkes",
                                  "optionId": "new_Side Dishes_1708028464083_408"
                              },
                              {
                                  "cost": "1",
                                  "name": "French Fries",
                                  "optionId": "new_Side Dishes_1708028526156_693"
                              },
                              {
                                  "cost": "1",
                                  "name": "Spicy Fries",
                                  "optionId": "new_Side Dishes_1708028540352_192"
                              },
                              {
                                  "cost": "1",
                                  "name": "Mixed Fries",
                                  "optionId": "new_Side Dishes_1708028549439_725"
                              },
                              {
                                  "cost": "2",
                                  "name": "Sweet Potato Fries",
                                  "optionId": "new_Side Dishes_1708028559272_592"
                              },
                              {
                                  "cost": "1",
                                  "name": "Broccoli Salad",
                                  "optionId": "new_Side Dishes_1708028574415_694"
                              },
                              {
                                  "cost": "1",
                                  "name": "Diet Broccoli Salad",
                                  "optionId": "new_Side Dishes_1708028589084_380"
                              },
                              {
                                  "cost": "1",
                                  "name": "Coleslaw",
                                  "optionId": "new_Side Dishes_1708028607089_449"
                              },
                              {
                                  "cost": "1",
                                  "name": "Diet Coleslaw",
                                  "optionId": "new_Side Dishes_1708028628084_416"
                              },
                              {
                                  "cost": "1",
                                  "name": "Cucumber Salad",
                                  "optionId": "new_Side Dishes_1708028680874_314"
                              },
                              {
                                  "cost": "1",
                                  "name": "Diet Cucumber Salad",
                                  "optionId": "new_Side Dishes_1708028688790_429"
                              },
                              {
                                  "cost": "1",
                                  "name": "Israeli Salad",
                                  "optionId": "new_Side Dishes_1708028725523_168"
                              },
                              {
                                  "cost": "0",
                                  "name": "No Sides",
                                  "optionId": "new_Side Dishes_1708028755027_95"
                              }
                          ],
                          "showByDefault": true,
                          "selectionMessage": "Please Select S"
                      }
                  },
                  "basePrice": "4.00"
              },
              {
                  "id": "6998198911054",
                  "title": "Salmon Atlantic Ground",
                  "options": {
                      "Onions": {
                          "type": "pill",
                          "items": [
                              {
                                  "cost": "0",
                                  "name": "Yes Onions ",
                                  "optionId": "new_Onions_1707937375284_136"
                              },
                              {
                                  "cost": "0",
                                  "name": "No Onions",
                                  "optionId": "new_Onions_1707937383820_385"
                              }
                          ],
                          "helpText": "",
                          "required": true,
                          "selectionMessage": "Please Select Onions"
                      }
                  },
                  "basePrice": "17.00"
              },
          ],
          "storeId": "58866368590",
          "storeName": "Sample Store",
          "updatedAt": "2024-05-07T14:05:46.274Z"
      }
    ];
   //////////////////////////////////////////////////////////
   const itemProductData = storeData.flatMap(store => store.sandwiches).find(sandwich => sandwich.id === CFG.productId); // console.log(itemProductData);
   const sandwichIds = storeData[0].sandwiches.map(sandwich => sandwich.id);
   window.sandwichIds = sandwichIds;
   document.addEventListener('DOMContentLoaded', () => {
      preliminary(storeData, itemProductData)  
   });
   //////////////////////////////////////////////////////////
  } 
  else {
   //////////////////////////////////////////////////////////
   // METAFIELD-BASED DATA LOADING (replaces Gadget API fetch)
   //////////////////////////////////////////////////////////
   let storeData = [{ sandwiches: [] }];
   let itemProductData = undefined;

   if (CFG.productOptions) {
     const pdpOptionsRaw = CFG.productOptions;
     const pdpOptions = parseFoodifyOptions(pdpOptionsRaw);
     if (pdpOptions) {
       itemProductData = pdpOptions;
       itemProductData.id = String(itemProductData.id || CFG.productId);
       storeData = [{ sandwiches: [itemProductData] }];
     }
   }

   const sandwichIds = storeData[0].sandwiches.map(s => s.id);
   window.sandwichIds = sandwichIds;

   document.addEventListener('DOMContentLoaded', () => {
     preliminary(storeData, itemProductData);
   });
  }

  //////////////////////////////////////////////////////////
  function preliminary(storeData, itemProductData) {
    console.log(storeData); console.log(itemProductData);  
    if(window.location.href.includes("/cart")) {
      //////////////////////////////////////////////////////////
      waitForElmFoodify(`.cart-order__summary .line-item-x`).then(() => {
         let lineItems = document.querySelectorAll('.cart-order__summary .line-item-x'); // console.log(lineItems);
         lineItems.forEach((lineItem, index) => {
           let lineId = lineItem.getAttribute('data-line-id')
           let productId = lineItem.getAttribute('data-product-id')
           let productTitle = lineItem.getAttribute('data-product-title')
           let productSKU = lineItem.getAttribute('data-product-sku')
           let lineItemKey = lineItem.getAttribute('data-line-key')
           let editButton = lineItem.querySelector('.edit-button-item')
           let lineItemProperties = lineItem.getAttribute('data-foodify-properties')
           let lineItemModal = lineItem.querySelector('.modal')
           // console.log(editButton); console.log(lineItem); console.log(productId);
           
           let singleProductData = { lineId, productId, productTitle, productSKU, lineItemKey }; // console.log("foodify ", index, lineId, productId, singleProductData)
           let foodifyOptionsAttr = lineItem.getAttribute('data-foodify-options');
           let itemProductData = null;
           if (foodifyOptionsAttr) {
             const parsedOpts = parseFoodifyOptions(foodifyOptionsAttr);
             if (parsedOpts) {
               itemProductData = parsedOpts;
               itemProductData.id = String(itemProductData.id || productId);
               storeData = [{ sandwiches: [itemProductData] }];
             }
           }

           if(itemProductData){
             window.hasSandwich = true;
             if(editButton){ editButton.style.display= 'flex'; }
             generateProductOptions(storeData, itemProductData, true, lineId, singleProductData)

             // TODO: Change to find out when it's ready to fill
             setTimeout(()=>{ fillModal(lineItem, lineItemProperties, lineItemModal) },'1000')
           }
           else {
             if(lineItem.querySelector('.edit-button-item ')) { lineItem.querySelector('.edit-button-item ').remove() }
           }
         });
       });
      //////////////////////////////////////////////////////////
    }
    else if(isCollectionListingPage()) {
        // console.log("on collection || on search")
        //////////////////////////////////////////////////////////////////////////
        // Search pages render `shopify-section--main-search`, not `--main-collection`,
        // so resolve either. Observing a null node throws and aborts everything below.
        const section = document.querySelector('section.shopify-section--main-collection')
          || document.querySelector('section.shopify-section--main-search');
        // Load items as they come into view
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const lineItem = entry.target;
              let productId = lineItem.getAttribute('data-product-id');
              const foodifyOptionsAttr = lineItem.getAttribute('data-foodify-options');
              let itemProductData = null;
              if (foodifyOptionsAttr) {
                const parsedOpts = parseFoodifyOptions(foodifyOptionsAttr);
                if (parsedOpts) {
                  itemProductData = parsedOpts;
                  itemProductData.id = String(itemProductData.id || productId);
                  storeData = [{ sandwiches: [itemProductData] }];
                }
              }
              if(itemProductData){
                window.hasSandwich = true;
                // The trigger and the hidden stepper are rendered server-side in
                // product-card.liquid now, so nothing here changes visible UI —
                // no observer chain, no flip. Opening is handled by MicroModal
                // (for cards present at init) or by the delegated listener above
                // (for cards added later), so this adds no click listener of its own.
                const customizeBtn = lineItem.querySelector('.atc-nextgen button');
                if (customizeBtn) {
                  // Belt and braces for any card rendered by an older template.
                  customizeBtn.setAttribute('data-custom-open', `modal-${productId}`);
                  // Empty so the button doesn't also open the quick-buy drawer.
                  customizeBtn.setAttribute('aria-controls', '');
                }
                let singleProductData = {
                  lineId: lineItem.getAttribute('data-line-id'),
                  productId,
                  productTitle: lineItem.getAttribute('data-product-title'),
                  productSKU: lineItem.getAttribute('data-product-sku'),
                  lineItemKey: lineItem.getAttribute('data-line-key')
                };
      
                waitForElmFoodify(`#modal-${productId} .options-foodify-container`).then(() => {
                  // The container's existence is already awaited above; the old
                  // 250ms timeout here just added latency.
                  generateProductOptions(storeData, itemProductData, true, productId, singleProductData, lineItem);
                });
     
              } 
              else {
                if(lineItem.querySelector('.edit-button-item')){ lineItem.querySelector('.edit-button-item').remove(); }
                let foodModal = lineItem.querySelector('.modal');
                if(foodModal){ foodModal.remove(); }
              }
              observer.unobserve(lineItem);
            }
          });
        }, { rootMargin: '0px', threshold: 0.1 });
        function observeNewProductCards() {
          const lineItems = document.querySelectorAll('product-list product-card.collection-item-x:not([data-observed])');
          lineItems.forEach(lineItem => {
            lineItem.setAttribute('data-observed', 'true');
            observer.observe(lineItem);
          });
        }
        observeNewProductCards();
        if (section) {
          const mutationObserver = new MutationObserver((mutations) => {
            mutations.forEach(mutation => {
              if (mutation.type === 'childList') {
                observeNewProductCards();
              }
            });
          });
          mutationObserver.observe(section, { childList: true, subtree: true });
        }
        //////////////////////////////////////////////////////////
    }
    else {
      if (itemProductData !== undefined) {
          window.hasSandwich = true;
          generateProductOptions(storeData, itemProductData);
       }
     }
  }
  //////////////////////////////////////////////////////////

  /*  Create The Products Options & Insert  */
  function generateProductOptions(storeData, optionsData, forMultiple = false, itemSelector = '', singleProductData, productElement) {
     ///////////////////////////////////////////////////////////////
     // if(singleProductData){console.log("Generate > ",singleProductData.productTitle, productElement)}
  
     const productOptionsContainer = document.createElement('div');
     productOptionsContainer.id = 'product-options';
     productOptionsContainer.setAttribute('data-base', CFG.variantPrice ||  productElement?.getAttribute('data-product-price') || optionsData.basePrice || '0');
     productOptionsContainer.setAttribute('data-base-default', CFG.productPrice ||  productElement?.getAttribute('data-product-price') || optionsData.basePrice || '0');

     const pdpCustomWeightEnabled = CFG.pdpCustomWeightEnabled;
     const elementCustomWeightEnabled = productElement?.getAttribute('data-custom-weight-enabled') === 'true';
     if ((pdpCustomWeightEnabled && !forMultiple) || elementCustomWeightEnabled) {
       productOptionsContainer.dataset.customWeightEnabled = 'true';
       const pricePerLb = productElement?.getAttribute('data-price-per-lb')
         || CFG.pricePerLb;
       if (pricePerLb) productOptionsContainer.dataset.pricePerLb = pricePerLb;
     }
     const style = document.createElement('style');
     style.type = 'text/css';
     style.innerHTML = `input.knhjd-pic[type="radio"]:checked + label { outline: 4px solid ${normal_bg_color}; } input.knhjd-pic[type="checkbox"]:checked + label { outline: 4px solid ${normal_bg_color}; }`;
     document.head.appendChild(style);

     const sortedCategories = Object.keys(optionsData.options).sort((a, b) => (optionsData.options[a].sortIndex || Infinity) - (optionsData.options[b].sortIndex || Infinity));
     const hiddenByShowRules = getCategoriesHiddenByShowRules(optionsData);

 
     sortedCategories.forEach(categoryName => {
        const category = optionsData.options[categoryName];
        const effectiveLimits = getEffectiveLimits(category, optionsData, categoryName);
        // console.log(category.sortIndex)
        const categoryOptions = category.items;
       // console.log(categoryOptions)
        const categoryType = category.type;
        const categoryId = category.id;
        if (!categoryOptions || categoryOptions.length === 0) return;
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'product-option';
        fieldset.id = categoryId;
        fieldset.classList.add('foodify-fieldset');
        fieldset.dataset.type = categoryNameToSlug(categoryName);
        fieldset.dataset.id = categoryNameToSlug(categoryName);
        fieldset.dataset.categoryName = categoryName;
        const showByDefault = category.showByDefault;
        if (showByDefault === 'false' || showByDefault === false || hiddenByShowRules.has(categoryName)) {
           fieldset.style.display = 'none';
           fieldset.dataset.notIncluded = true;
        }
        const legend = document.createElement('legend');
        legend.className = 'form__label';
        const isRequired = effectiveLimits.required || category.required;
        legend.textContent = (categoryType === 'select' || isRequired) ? `${categoryName}: *` : `${categoryName}:`;
        if (isRequired) {
           fieldset.dataset.required = 'true';
        }
        if (category.helpText && category.helpText != '') {
           const span = document.createElement('span');
           span.textContent = category.helpText || ``;
           span.className = 'foodify-disclaim'
           span.style.marginLeft = '15px'
           span.style.fontWeight = 'normal'
           span.style.fontSize = '17px'
           span.style.opacity = '0.7'
           legend.appendChild(span);
        }
        fieldset.appendChild(legend);
        const optionsContainer = document.createElement('div');
        optionsContainer.className = 'options';
        optionsContainer.style.display = 'flex';
        optionsContainer.style.flexWrap = 'wrap';
        optionsContainer.style.columnGap = '15px';
        optionsContainer.style.rowGap = '5px';
       
        // console.log(categoryOptions)

        const itemWithSKU = categoryOptions.find(item => item.useSKU);
        if (itemWithSKU) {
        //-console.log(itemWithSKU.sku);
          fieldset.setAttribute('data-sku', itemWithSKU.sku);
        }
       
        ///////////////////////////////////////////////////////////////
        if (categoryType === 'select') {
           ///////////////////////////////////////////////////////////////
           const select = document.createElement('select');
           select.className = 'option select knhjd';
           select.name = `properties[${categoryName}]`;
           select.dataset.use = 'extra-option';
           select.required = category.required == 'true' ? 'true' : 'false';
           select.id = categoryId;
           const placeholderOption = document.createElement('option');
           placeholderOption.textContent = category.selectionMessage || `Please Select ${categoryName}`;
           placeholderOption.value = '';
           placeholderOption.disabled = true;
           placeholderOption.selected = true;
           placeholderOption.dataset.price = '0';
           select.style.marginBottom = "0px";
           select.appendChild(placeholderOption);
           categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
              if (option.type && option.type == 'rule') {} else {
                 const selectOption = document.createElement('option');
                 selectOption.value = option.name;
                 selectOption.id = option.optionId;
                 selectOption.dataset.price = option.cost;
                 selectOption.textContent = option.name;
                 select.appendChild(selectOption);
              }
           });


           const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svgElement.setAttribute("role", "presentation");
            svgElement.setAttribute("focusable", "false");
            svgElement.setAttribute("width", "10");
            svgElement.setAttribute("height", "7");
            svgElement.setAttribute("class", "select-chevron icon icon-chevron-bottom");
            svgElement.setAttribute("viewBox", "0 0 10 7");
            
            const pathElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
            pathElement.setAttribute("d", "m1 1 4 4 4-4");
            pathElement.setAttribute("fill", "none");
            pathElement.setAttribute("stroke", "currentColor");
            pathElement.setAttribute("stroke-width", "2");
            
            svgElement.appendChild(pathElement);
            
            


          
           optionsContainer.appendChild(select);
           optionsContainer.appendChild(svgElement);
           ///////////////////////////////////////////////////////////////
        } 
        else if (categoryType === 'image') {
          ///////////////////////////////////////////////////////////////
          categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
              if (option.type && option.type == 'rule') {} else {
                 const input = document.createElement('input');
                 input.className = `${categoryType} knhjd knhjd-pic`;
                 input.type = 'radio';
                 input.id = option.optionId;
                 input.value = option.name;
                 input.dataset.price = option.cost;
                 input.name = `properties[${categoryName}]`;
                 input.dataset.use = 'extra-option';
                 input.hidden = true;
                 const label = document.createElement('label');
                 label.htmlFor = input.id;
                 label.style.cursor = 'pointer';
                 label.style.display = 'inline-block';
                 label.style.position = 'relative';
                 label.style.marginBottom = '30px';
                 label.dataset.link = option.name;
                 const img = document.createElement('img');
                 img.src = option.imageUrl;
                 img.alt = option.name;
                 img.style.width = '100px';
                 img.style.height = '100px';
                 img.style.objectFit = 'cover';
                 img.style.objectPosition = 'center';
                 label.appendChild(img);
                 const span = document.createElement('span');
                 span.textContent = option.name;
                 span.style.position = 'absolute';
                 span.style.bottom = '-35px';
                 span.style.left = '0px';
                 label.appendChild(span);
                 const optionDiv = document.createElement('div');
                 optionDiv.className = 'option';
                 optionDiv.appendChild(input);
                 optionDiv.appendChild(label);
                 optionsContainer.appendChild(optionDiv);
                 label.addEventListener('click', () => {
                    input.checked = true;
                    const customChangeEvent = new Event("change", {
                       bubbles: true,
                    });
                    input.dispatchEvent(customChangeEvent);
                 });
                 input.addEventListener('click', function(e) {
                    if (input.getAttribute('data-last-clicked') === 'true') {
                       input.checked = false;
                       input.setAttribute('data-last-clicked', 'false');
                    } else {
                       const radios = document.querySelectorAll(`input[name="${input.name}"]`);
                       radios.forEach(radio => radio.setAttribute('data-last-clicked', 'false'));
                       input.setAttribute('data-last-clicked', 'true');
                    }
                 });
              }
           });
          ///////////////////////////////////////////////////////////////
        } 
        else if (categoryType === 'image-multi') {
           ///////////////////////////////////////////////////////////////
           const hasLimit = !!(category.optionLimit && parseInt(category.optionLimit) > 0);
           const inputs = [];
           
           // Add selection count display if limit exists
           let limitMessageSpan = null;
           if (hasLimit && category.optionLimit) {
              limitMessageSpan = document.createElement('span');
              limitMessageSpan.className = 'limit-message';
              limitMessageSpan.style.marginLeft = '15px';
              limitMessageSpan.style.fontWeight = 'normal';
              limitMessageSpan.style.fontSize = '14px';
              limitMessageSpan.style.opacity = '0.7';
              limitMessageSpan.textContent = `(Select up to ${category.optionLimit})`;
              legend.appendChild(limitMessageSpan);
           }
           
           if (!hasLimit) {}
           categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
              if (option.type && option.type == 'rule') {} else {
                 const input = document.createElement('input');
                 input.className = `${categoryType} knhjd knhjd-pic `;
                 input.type = 'checkbox';
                 input.id = option.optionId;
                 input.value = option.name;
                 input.dataset.price = option.cost;
                 input.name = `properties[${categoryName}-${index + 1}]`;
                 input.dataset.use = 'extra-option';
                 input.hidden = true;
                 const label = document.createElement('label');
                 label.htmlFor = input.id;
                 label.style.cursor = 'pointer';
                 label.style.display = 'inline-block';
                 label.style.position = 'relative';
                 label.style.marginBottom = '30px';
                 label.dataset.link = option.name;
                 const img = document.createElement('img');
                 img.src = option.imageUrl;
                 img.alt = option.name;
                 img.style.width = '100px';
                 img.style.height = '100px';
                 img.style.objectFit = 'cover';
                 img.style.objectPosition = 'center';
                 label.appendChild(img);
                 const span = document.createElement('span');
                 span.textContent = option.name;
                 span.style.position = 'absolute';
                 span.style.bottom = '-35px';
                 span.style.left = '0px';
                 label.appendChild(span);
                 const optionDiv = document.createElement('div');
                 optionDiv.className = 'option';
                 
                 optionDiv.appendChild(input);
                 optionDiv.appendChild(label);
                 optionsContainer.appendChild(optionDiv);
                 label.addEventListener('click', () => {
                    const customChangeEvent = new Event("change", {
                       bubbles: true,
                    });
                    input.dispatchEvent(customChangeEvent);
                 });
                 if (hasLimit) inputs.push(input);
              }
           });
           if (hasLimit) {
              // Function to update limit message
              const updateLimitMessage = () => {
                 if (limitMessageSpan) {
                    const checkedCount = inputs.filter(checkbox => checkbox.checked).length;
                    limitMessageSpan.textContent = `(${checkedCount} of ${category.optionLimit} selected)`;
                 }
              };
              
              inputs.forEach(input => {
                 input.addEventListener('change', (event) => {
                    const optionLimitValue = parseInt(category.optionLimit) || 0;
                    let hardLimitNumberValue = parseInt(category.hardLimitNumber);
                    let isHardLimitNumber = !isNaN(hardLimitNumberValue) && hardLimitNumberValue > 0;
                    if (isHardLimitNumber) hardLimitNumberValue = Math.max(hardLimitNumberValue, optionLimitValue);
                   
                    const checkedInputs = inputs.filter(checkbox => checkbox.checked);
                    
                    // Update limit message
                    updateLimitMessage();
                    
                    if(isHardLimitNumber) {
                      
                      if (checkedInputs.length >= hardLimitNumberValue) {
                         inputs.forEach(checkbox => {
                            if (!checkbox.checked) checkbox.disabled = true;
                         });
                      } else {
                         inputs.forEach(checkbox => {
                            checkbox.disabled = false;
                         });
                      }

                      if (checkedInputs.length > optionLimitValue) {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-additionalcost")) {
                              if (!checkbox.checked || checkbox === event.target) {
                                checkbox.setAttribute("data-price", checkbox.getAttribute("data-additionalcost") || checkbox.getAttribute("data-originalcost"));
                              }
                            }
                          }, 150);
                        });
                      } 
                      else if (checkedInputs.length == optionLimitValue) {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-originalcost")) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                            }
                          }, 150);
                        });
                      } 
                      else {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-originalcost")) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                            }
                          }, 150);
                        });
                      } 
                      
                    } 
                    else {
                      if (checkedInputs.length >= optionLimitValue) {
                         inputs.forEach(checkbox => {
                            if (!checkbox.checked) checkbox.disabled = true;
                         });
                      } 
                      else {
                         inputs.forEach(checkbox => {
                            checkbox.disabled = false;
                         });
                      }
                    }
                   
                 });
              });
              
              // Initialize limit message
              updateLimitMessage();
           }
           ///////////////////////////////////////////////////////////////
        } 
        else if (categoryType === 'pill') {
           ///////////////////////////////////////////////////////////////
           const inputs = [];
           categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
             
              if (option.type && option.type == 'rule') {} 
              else {
                 const input = document.createElement('input');
                 input.className = `${categoryType} knhjd`;
                 input.type = 'radio';
                 input.id = option.optionId;
                 input.value = option.name;
                 input.dataset.price = option.cost;
                 input.name = categoryType === 'pill' ? `properties[${categoryName}]` : `properties[${categoryName}-${index + 1}]`;
                 input.dataset.use = 'extra-option';
                 if(category.required)  input.required =  'true';
                 const label = document.createElement('label');
                 label.className = `pill`
                 label.setAttribute('for', input.id);
                 label.style.paddingInlineStart = '5px';
                 label.style.color = 'rgb(var(--text-color))';
                 label.textContent = option.name;
                 label.dataset.link = option.name;
                 const optionDiv = document.createElement('div');
                 optionDiv.className = 'option';
                 
                 optionDiv.appendChild(input);
                 optionDiv.appendChild(label);
                 optionsContainer.appendChild(optionDiv);
                 if (categoryType === 'pill') {
                    label.addEventListener('click', function(e) {
                       console.log('🖱️ LABEL CLICKED (pill):', {
                          value: input.value,
                          name: input.name,
                          currentChecked: input.checked,
                          dataLastClicked: input.getAttribute('data-last-clicked')
                       });
                       e.stopPropagation()
                       if (input.getAttribute('data-last-clicked') === 'true') {
                          console.log('📤 Dispatching change event (unchecking)');
                          const changeEvent = new Event('change', {
                             bubbles: true,
                             cancelable: true
                          });
                          input.dispatchEvent(changeEvent);
                          input.checked = false;
                          input.setAttribute('data-last-clicked', 'false');
                       } else {
                          console.log('📤 Dispatching change event (checking)');
                          input.checked = true;
                          const radios = document.querySelectorAll(`input[name="${input.name}"]`);
                          radios.forEach(radio => radio.setAttribute('data-last-clicked', 'false'));
                          input.setAttribute('data-last-clicked', 'true');
                          const changeEvent = new Event('change', {
                             bubbles: true,
                             cancelable: true
                          });
                          input.dispatchEvent(changeEvent);
                       }
                    });
                 }
               }

           });
           ///////////////////////////////////////////////////////////////
        }
        else if (categoryType === 'pill-multi') {
           ///////////////////////////////////////////////////////////////
           const hasLimit = !!(category.optionLimit && parseInt(category.optionLimit) > 0);
           const inputs = [];
           const inputLabelPairs = []; // Store input-label pairs for limit handling
           
           // Add selection count display if limit exists
           let limitMessageSpan = null;
           if (hasLimit && category.optionLimit) {
              limitMessageSpan = document.createElement('span');
              limitMessageSpan.className = 'pill-multi-limit-message';
              limitMessageSpan.style.marginLeft = '15px';
              limitMessageSpan.style.fontWeight = 'normal';
              limitMessageSpan.style.fontSize = '14px';
              limitMessageSpan.style.opacity = '0.7';
              limitMessageSpan.textContent = `(Select up to ${category.optionLimit})`;
              legend.appendChild(limitMessageSpan);
           }
           
           if (!hasLimit) {}
           categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
             
              if (option.type && option.type == 'rule') {} 
              else {
                 const input = document.createElement('input');
                 input.className = `pill-multi knhjd`;
                 input.type = 'checkbox';
                 input.id = option.optionId;
                 input.value = option.name;
                 input.dataset.price = option.cost;
                 input.dataset.originalcost = option.cost;
                 input.dataset.additionalcost = option.additionalCost;
                 input.name = `properties[${categoryName}-${index + 1}]`;
                 input.dataset.use = 'extra-option';
                 const label = document.createElement('label');
                 label.className = `pill`
                 label.setAttribute('for', input.id);
                 label.textContent = option.name;
                 label.dataset.link = option.name;
                 const optionDiv = document.createElement('div');
                 optionDiv.className = 'option';
                 
                 optionDiv.appendChild(input);
                 optionDiv.appendChild(label);
                 optionsContainer.appendChild(optionDiv);
                 
                 label.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if (!input.disabled) {
                       input.checked = !input.checked;
                       const changeEvent = new Event('change', { bubbles: true });
                       input.dispatchEvent(changeEvent);
                    }
                 });
                 
                 if (hasLimit) {
                    inputs.push(input);
                    inputLabelPairs.push({ input: input, label: label });
                 }
              }
           });
           if (hasLimit) {
              // Function to update limit message
              const updateLimitMessage = () => {
                 if (limitMessageSpan) {
                    const checkedCount = inputs.filter(checkbox => checkbox.checked).length;
                    limitMessageSpan.textContent = `(${checkedCount} of ${category.optionLimit} selected)`;
                 }
              };
              
              inputs.forEach(input => {
                 input.addEventListener('change', (event) => {
                    const optionLimitValue = parseInt(category.optionLimit) || 0;
                    let hardLimitNumberValue = parseInt(category.hardLimitNumber);
                    let isHardLimitNumber = !isNaN(hardLimitNumberValue) && hardLimitNumberValue > 0;
                    if (isHardLimitNumber) hardLimitNumberValue = Math.max(hardLimitNumberValue, optionLimitValue);
                   
                    const checkedInputs = inputs.filter(checkbox => checkbox.checked);
                    
                    // Update limit message
                    updateLimitMessage();
                    
                    if(isHardLimitNumber) {
                      
                      if (checkedInputs.length >= hardLimitNumberValue) {
                         inputLabelPairs.forEach((pair) => {
                            const checkbox = pair.input;
                            const labelElement = pair.label;
                            if (!checkbox.checked) {
                               checkbox.disabled = true;
                               labelElement.classList.add('pill-disabled');
                               labelElement.style.opacity = '0.5';
                               labelElement.style.cursor = 'not-allowed';
                            }
                         });
                      } else {
                         inputLabelPairs.forEach((pair) => {
                            const checkbox = pair.input;
                            const labelElement = pair.label;
                            checkbox.disabled = false;
                            labelElement.classList.remove('pill-disabled');
                            labelElement.style.opacity = '1';
                            labelElement.style.cursor = 'pointer';
                         });
                      }

                      if (checkedInputs.length > optionLimitValue) {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-additionalcost")) {
                              if (!checkbox.checked || checkbox === event.target) {
                                checkbox.setAttribute("data-price", checkbox.getAttribute("data-additionalcost") || checkbox.getAttribute("data-originalcost"));
                              }
                            }
                          }, 150);
                        });
                      } 
                      else if (checkedInputs.length == optionLimitValue) {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-originalcost")) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                            }
                          }, 150);
                        });
                      } 
                      else {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-originalcost")) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                            }
                          }, 150);
                        });
                      } 
                      
                    } 
                    else {
                      if (checkedInputs.length >= optionLimitValue) {
                         inputLabelPairs.forEach((pair) => {
                            const checkbox = pair.input;
                            const labelElement = pair.label;
                            if (!checkbox.checked) {
                               checkbox.disabled = true;
                               labelElement.classList.add('pill-disabled');
                               labelElement.style.opacity = '0.5';
                               labelElement.style.cursor = 'not-allowed';
                            }
                         });
                      } 
                      else {
                         inputLabelPairs.forEach((pair) => {
                            const checkbox = pair.input;
                            const labelElement = pair.label;
                            checkbox.disabled = false;
                            labelElement.classList.remove('pill-disabled');
                            labelElement.style.opacity = '1';
                            labelElement.style.cursor = 'pointer';
                         });
                      }
                    }
                   
                 });
              });
              
              // Initialize limit message
              updateLimitMessage();
           }
           ///////////////////////////////////////////////////////////////
        }
        else {
           ///////////////////////////////////////////////////////////////
           const hasLimit = !!(category.optionLimit && parseInt(category.optionLimit) > 0);
           const inputs = [];
           
           // Add selection count display if limit exists
           let limitMessageSpan = null;
           if (hasLimit && category.optionLimit) {
              limitMessageSpan = document.createElement('span');
              limitMessageSpan.className = 'limit-message';
              limitMessageSpan.style.marginLeft = '15px';
              limitMessageSpan.style.fontWeight = 'normal';
              limitMessageSpan.style.fontSize = '14px';
              limitMessageSpan.style.opacity = '0.7';
              limitMessageSpan.textContent = `(Select up to ${category.optionLimit})`;
              legend.appendChild(limitMessageSpan);
           }
           
           if (!hasLimit) {}
           categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
              if (option.type && option.type == 'rule') {} 
              else {
                 const input = document.createElement('input');
                 input.className = `${categoryType} knhjd`;
                 input.type = categoryType;
                 input.id = option.optionId;
                 input.value = option.name;
                 input.dataset.price = option.cost;
                 input.dataset.originalcost = option.cost;
                 input.dataset.additionalcost = option.additionalCost;
                 input.name = categoryType === 'radio' ? `properties[${categoryName}]` : `properties[${categoryName}-${index + 1}]`;
                 input.dataset.use = 'extra-option';
                 const label = document.createElement('label');
                 label.setAttribute('for', input.id);
                 label.style.paddingInlineStart = '5px';
                 label.style.color = 'rgb(var(--text-color))';
                 label.textContent = option.name;
                 label.dataset.link = option.name;
                 const optionDiv = document.createElement('div');
                 optionDiv.className = 'option';

                 if(categoryType === 'checkbox'){
                 label.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if (!input.disabled) {
                       input.checked = !input.checked;
                       const clickEvent = new Event('change', { bubbles: true });
                       input.dispatchEvent(clickEvent);
                    }
                 });
                 }
                 
                 optionDiv.appendChild(input);
                 optionDiv.appendChild(label);
                 optionsContainer.appendChild(optionDiv);
                 if(category.required && categoryType === 'radio') input.required = 'true';
                 if (categoryType === 'radio' && forMultiple) {
                  
                  const handleInputClick = function(e) {
                      console.log('🖱️ INPUT/LABEL CLICKED (radio forMultiple):', {
                         value: input.value,
                         name: input.name,
                         currentChecked: input.checked,
                         dataLastClicked: input.getAttribute('data-last-clicked')
                      });
                      e.stopPropagation();
                      if (input.getAttribute('data-last-clicked') === 'true') {
                          console.log('📤 Dispatching change event (unchecking - forMultiple)');
                          const changeEvent = new Event('change', {
                              bubbles: true,
                              cancelable: true
                          });
                          input.dispatchEvent(changeEvent);
                          input.checked = false;
                          input.setAttribute('data-last-clicked', 'false');
                      } else {
                          console.log('📤 Dispatching change event (checking - forMultiple)');
                          input.checked = true;
                          const radios = document.querySelectorAll(`input[name="${input.name}"]`);
                          radios.forEach(radio => radio.setAttribute('data-last-clicked', 'false'));
                          input.setAttribute('data-last-clicked', 'true');
                          const changeEvent = new Event('change', {
                              bubbles: true,
                              cancelable: true
                          });
                          input.dispatchEvent(changeEvent);
                      }
                  };
              
                  input.addEventListener('click', handleInputClick);
                  label.addEventListener('click', handleInputClick);
                 }
                 if (hasLimit) inputs.push(input);
              }
           });
           if (hasLimit) {
              // Function to update limit message
              const updateLimitMessage = () => {
                 if (limitMessageSpan) {
                    const checkedCount = inputs.filter(checkbox => checkbox.checked).length;
                    limitMessageSpan.textContent = `(${checkedCount} of ${category.optionLimit} selected)`;
                 }
              };
              
              inputs.forEach(input => {
                 input.addEventListener('change', (event) => {
                    const optionLimitValue = parseInt(category.optionLimit) || 0;
                    let hardLimitNumberValue = parseInt(category.hardLimitNumber);
                    let isHardLimitNumber = !isNaN(hardLimitNumberValue) && hardLimitNumberValue > 0;
                    if (isHardLimitNumber) hardLimitNumberValue = Math.max(hardLimitNumberValue, optionLimitValue);
                   
                    const checkedInputs = inputs.filter(checkbox => checkbox.checked);
                    
                    // Update limit message
                    updateLimitMessage();
 
                    if(isHardLimitNumber) {
                      
                      if (checkedInputs.length >= hardLimitNumberValue) {
                         inputs.forEach(checkbox => {
                            if (!checkbox.checked) checkbox.disabled = true;
                         });
                      } 
                      else {
                         inputs.forEach(checkbox => {
                            checkbox.disabled = false;
                         });
                      }

                      if (checkedInputs.length > optionLimitValue) {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-additionalcost")) {
                              if (!checkbox.checked || checkbox === event.target) {
                                checkbox.setAttribute("data-price", checkbox.getAttribute("data-additionalcost") || checkbox.getAttribute("data-originalcost"));
                              }
                            }
                          }, 150);
                        });
                      } 
                      else if (checkedInputs.length == optionLimitValue) {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-originalcost")) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                            }
                          }, 150);
                        });
                      } 
                      else {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-originalcost")) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                            }
                          }, 150);
                        });
                      } 
                      
                    } 
                    else {
                      if (checkedInputs.length >= optionLimitValue) {
                         inputs.forEach(checkbox => {
                            if (!checkbox.checked) checkbox.disabled = true;
                         });
                      } 
                      else {
                         inputs.forEach(checkbox => {
                            checkbox.disabled = false;
                         });
                      }
                    }
                    
                 });
              });
              
              // Initialize limit message
              updateLimitMessage();
           }
           ///////////////////////////////////////////////////////////////
        }
        ///////////////////////////////////////////////////////////////


       setTimeout(()=> {
          // document.querySelectorAll('.variant-options-area .option label').forEach(label => {
          //           console.log(label)
          //             label.addEventListener('click', event => {
          //                 const input = document.getElementById(label.getAttribute('for'));
          //                 if (input) {
          //                     input.checked = true;
          //                     const clickEvent = new Event('click', { bubbles: true });
          //                     input.dispatchEvent(clickEvent);
          //                   console.log(`Label clicked: ${label.getAttribute('for')}`);
          //                 }
          //             });
          //         });
       },'150')
         
       
        fieldset.appendChild(optionsContainer);
        fieldset.appendChild(document.createElement('br'));
        productOptionsContainer.appendChild(fieldset);
      


/*       
// Check if there is a limit on the number of options that can be selected and if the category type is 'checkbox'
if (category.optionLimit && category.optionLimit != 0 && categoryType === 'checkbox') {
  // Select all checkbox elements within the fieldset
  const checkboxes = fieldset.querySelectorAll('.checkbox');
  
  // Define a function to update the selection count
  const updateSelectionCount = () => {
    // Count the number of checkboxes that are currently checked
    const selectedCount = Array.from(checkboxes).filter(checkbox => checkbox.checked).length;
    
    // Check if the number of selected checkboxes exceeds the limit
    if (Number(selectedCount) > Number(category.optionLimit)) {
      // Iterate over the category options and update the price attribute
      categoryOptions.forEach((option, index) => {
        if (index < Number(category.optionLimit)) {
          // Set the price attribute to 0 for options within the limit
          checkboxes[index].setAttribute('data-price', 0);
        } else {
          // Set the price attribute to the additional cost for options outside the limit, if the checkbox exists
          if(checkboxes[index]){
            checkboxes[index].setAttribute('data-price', option.additionalCost || 0);
          }
        }
      });
    } else {
      // If the number of selections does not exceed the limit, set the price attribute of all options to 0
      categoryOptions.forEach((option, index) => {
        if(checkboxes[index]){
          checkboxes[index].setAttribute('data-price', 0);
        }
      });
    }
  };
  // Add a 'change' event listener to each checkbox to update the selection count whenever any checkbox is toggled
  checkboxes.forEach(checkbox => checkbox.addEventListener('change', updateSelectionCount));
}

        */  



       
     });

     let uniqueSelector = itemSelector != '' ? `.modal#modal-${itemSelector} ` : '';

    // Clear the server-rendered "Loading options…" placeholder. Note we *prepend*
    // below rather than overwrite, so the placeholder has to be removed explicitly.
    const clearOptionsLoadingState = (container) => {
      if (!container) return;
      container.querySelectorAll('.foodify-options-loading').forEach((node) => node.remove());
    };

    //insert
     if(!forMultiple){
       let insertOptions = document.querySelector('form[method="post"][data-type="add-to-cart-form"][is="product-form"]')
       if (insertOptions) {
         // The container exists — insert now. The old setTimeout only added latency.
         clearOptionsLoadingState(insertOptions);
         insertOptions.prepend(productOptionsContainer);
         productOptionsContainer.style.display = 'block';
         foodifyInitialize(storeData)
       }
     }
     else {
       let insertOptions = document.querySelector(`${uniqueSelector}  main .options-foodify-container`)
       // console.log(uniqueSelector)
       if (insertOptions) {
         clearOptionsLoadingState(insertOptions);
         insertOptions.prepend(productOptionsContainer);
         productOptionsContainer.style.display = 'block';
         foodifyInitialize(storeData, forMultiple, uniqueSelector, singleProductData)
       }
     }

     if(!forMultiple){
      waitForElmFoodify(`#product-options fieldset`).then(() => {
       //-console.log("window on load")
         timer.stop('INSERT');
         
         // Use event delegation on #product-options to catch all change events from dynamically created inputs
         const productOptionsContainer = document.querySelector(`${uniqueSelector} #product-options`);
         if (productOptionsContainer) {
            console.log('✅ Setting up event delegation on #product-options');
            productOptionsContainer.addEventListener('change', function(event) {
               // Only handle events from foodify inputs
               if (event.target.matches('input[type="radio"], input[type="checkbox"], select') && 
                   event.target.closest('.foodify-fieldset')) {
                  console.log('🔔 EVENT DELEGATION CAUGHT CHANGE:', {
                     target: event.target,
                     value: event.target.value,
                     name: event.target.name,
                     checked: event.target.checked,
                     dataLastClicked: event.target.getAttribute('data-last-clicked'),
                     category: event.target.closest('.foodify-fieldset')?.dataset?.type
                  });
                  
                  reevaluateAllRules(uniqueSelector, optionsData, event);
               }
            });
         }
         
         Object.keys(optionsData.options).forEach(categoryName => {
            const category = optionsData.options[categoryName];
            const categoryLimits = getEffectiveLimits(category, optionsData, categoryName);
            let categoryOptions = category.items;
            categoryOptions.forEach(option => {
               if (option.type && option.type === 'rule') {
                  let { action, ruleFields, conditionLink, firstCondition, secondCondition, ruleId } = option;
                  const addEventListenersForOption = (option, categoryType, optionLimit) => {
                     const generateRuleWithOption = (event) => {
                        console.log('🔔 FOODIFY OPTION CHANGED (direct listener):', {
                           category: categoryName,
                           optionType: categoryType,
                           eventTarget: event.target,
                           value: event.target.value,
                           name: event.target.name,
                           checked: event.target.checked,
                           dataLastClicked: event.target.getAttribute('data-last-clicked')
                        });
                        reevaluateAllRules(uniqueSelector, optionsData, event);
                     };
                     waitForElmFoodify(`${uniqueSelector} #product-options .product-option select`).then(() => {
                        const selects = document.querySelectorAll(`${uniqueSelector} #product-options select`);
                        selects.forEach((select) => select.addEventListener("change", generateRuleWithOption));
                     });
                     waitForElmFoodify(`${uniqueSelector}  #product-options .product-option input[type="checkbox"]`).then(() => {
                        const checkboxes = document.querySelectorAll(`${uniqueSelector} #product-options input[type='checkbox']`);
                        checkboxes.forEach((checkbox) => checkbox.addEventListener("change", generateRuleWithOption));
                     });
                     waitForElmFoodify(`${uniqueSelector}  #product-options .product-option input[type="radio"]`).then(() => {
                        const radioboxes = document.querySelectorAll(`${uniqueSelector} #product-options input[type='radio']`);
                        radioboxes.forEach((radiobox) => radiobox.addEventListener("change", generateRuleWithOption));
                     });


                    
                      
                       ////////// For Native Variants //////////////////////
                     //-console.log("sok", uniqueSelector)
                       waitForElmFoodify(`${uniqueSelector} variant-radios input[type="radio"].native-variant`).then((elm) => {
                       //-console.log("sko222k", elm)
                       //-console.log(`${uniqueSelector} variant-radios input[type="radio"].native-variant`)
                          const radioboxes = document.querySelectorAll(`${uniqueSelector} variant-radios input[type='radio'].native-variant`);
                        //-console.log(":RAdios")
                        //-console.log(radioboxes)
                         
                           radioboxes.forEach((radiobox) => {
                             radiobox.addEventListener("change", (event) => {
                              updateBasePrice(event, radiobox); 
                              reevaluateAllRules(uniqueSelector, optionsData, event);
                            });
                           })
                          
                       });
                       function updateBasePrice(event, radiobox) {
                        console.log("update", radiobox)
                         
                          var productOptions = document.querySelector('#product-options');
                        //-console.log(productOptions)
                          if (productOptions) {
                            // console.log("enter--------")
                          console.log(radiobox.getAttribute('data-variant-price'))
                            if(radiobox.getAttribute('data-variant-price')){
                              productOptions.setAttribute('data-base', radiobox.getAttribute('data-variant-price'));
                            }
                            
                          }

                        }
                       ////////// End For Native Variants //////////////////


 
                  };
         
                  addEventListenersForOption(option, category.type, categoryLimits.optionLimit);
               }
            });


           
         });
         dispatchFirstInputChange(uniqueSelector, optionsData)
         if (typeof window.injectFoodifyCustomWeight === 'function') {
           window.injectFoodifyCustomWeight(uniqueSelector, optionsData);
         }
     });
    }
     else {
      setTimeout(() => {
           // Use event delegation on #product-options to catch all change events from dynamically created inputs
           const productOptionsContainer = document.querySelector(`${uniqueSelector} #product-options`);
           if (productOptionsContainer) {
              console.log('✅ Setting up event delegation on #product-options (forMultiple)');
              productOptionsContainer.addEventListener('change', function(event) {
                 // Only handle events from foodify inputs
                 if (event.target.matches('input[type="radio"], input[type="checkbox"], select') && 
                     event.target.closest('.foodify-fieldset')) {
                    console.log('🔔 EVENT DELEGATION CAUGHT CHANGE (forMultiple):', {
                       target: event.target,
                       value: event.target.value,
                       name: event.target.name,
                       checked: event.target.checked,
                       dataLastClicked: event.target.getAttribute('data-last-clicked'),
                       category: event.target.closest('.foodify-fieldset')?.dataset?.type
                    });
                    
                    reevaluateAllRules(uniqueSelector, optionsData, event);
                 }
              });
           }
           
           Object.keys(optionsData.options).forEach(categoryName => {
              const category = optionsData.options[categoryName];
              const categoryLimits = getEffectiveLimits(category, optionsData, categoryName);
              let categoryOptions = category.items;
              categoryOptions.forEach(option => {
                 if (option.type && option.type === 'rule') {
                    let { action, ruleFields, conditionLink, firstCondition, secondCondition, ruleId } = option;
                    const addEventListenersForOption = (option, categoryType, optionLimit) => {
                       const generateRuleWithOption = (event) => {
                          console.log('🔔 FOODIFY OPTION CHANGED (forMultiple - direct listener):', {
                             category: categoryName,
                             optionType: categoryType,
                             eventTarget: event.target,
                             value: event.target.value,
                             name: event.target.name,
                             checked: event.target.checked,
                             dataLastClicked: event.target.getAttribute('data-last-clicked')
                          });
                          reevaluateAllRules(uniqueSelector, optionsData, event);
                       };
                       waitForElmFoodify(`${uniqueSelector} #product-options .product-option select`).then(() => {
                          const selects = document.querySelectorAll(`${uniqueSelector} #product-options select`);
                          selects.forEach((select) => select.addEventListener("change", generateRuleWithOption));
                       });
                       waitForElmFoodify(`${uniqueSelector}  #product-options .product-option input[type="checkbox"]`).then(() => {
                          const checkboxes = document.querySelectorAll(`${uniqueSelector} #product-options input[type='checkbox']`);
                          checkboxes.forEach((checkbox) => checkbox.addEventListener("change", generateRuleWithOption));
                       });
                       waitForElmFoodify(`${uniqueSelector}  #product-options .product-option input[type="radio"]`).then(() => {
                          const radioboxes = document.querySelectorAll(`${uniqueSelector} #product-options input[type='radio']`);
                          radioboxes.forEach((radiobox) => radiobox.addEventListener("change", generateRuleWithOption));
                       });


                    };
                    addEventListenersForOption(option, category.type, categoryLimits.optionLimit);
                 }
                // sssss
                   
                 ////////// For Native Variants //////////////////////variant-options-area //
                 waitForElmFoodify(`${uniqueSelector} variant-radios  input[type="radio"].native-variant`).then((elm) => {

                    const radioboxes = document.querySelectorAll(`${uniqueSelector} variant-radios  input[type='radio'].native-variant`);
     
                     radioboxes.forEach((radiobox) => {
                       radiobox.addEventListener("change", (event) => {
                        updateBasePrice(event, radiobox, uniqueSelector); 
                        reevaluateAllRules(uniqueSelector, optionsData, event);
                      });
                     })
                    
                 });
                 function updateBasePrice(event, radiobox, uniqueSelector) {
                  // console.log("update", radiobox)
                   
                    var productOptions = document.querySelector(`${uniqueSelector} #product-options`);
           
                    if (productOptions) {
                    //   console.log(productOptions)
                    // console.log(radiobox.getAttribute('data-variant-price'))
                      if(radiobox.getAttribute('data-variant-price')){
                        productOptions.setAttribute('data-base', radiobox.getAttribute('data-variant-price'));
                        setTimeout(() => {
                            updateOptionsPrice(uniqueSelector);
                         }, 200);
                      }
                    }

                  }
                 ////////// End For Native Variants //////////////////

                
              });
           });
           dispatchFirstInputChange(uniqueSelector, optionsData)
           if (typeof window.injectFoodifyCustomWeight === 'function') {
             window.injectFoodifyCustomWeight(uniqueSelector, optionsData);
           }
      }, '500')
    }


   waitForElmFoodify(`${uniqueSelector} variant-radios input[type="radio"].native-variant:checked`).then((radiobox) => {
    setTimeout(() => {
        updateBasePrice(radiobox, uniqueSelector);
    }, 1000);

    function updateBasePrice(radiobox, uniqueSelector) {
        var productOptions = document.querySelector(`${uniqueSelector} #product-options`);
        if (productOptions && radiobox.getAttribute('data-variant-price')) {
            productOptions.setAttribute('data-base', radiobox.getAttribute('data-variant-price'));
            updateOptionsPrice(uniqueSelector);
          }
        }
    });



////////// For Native Variants //////////////////////
waitForElmFoodify(`${uniqueSelector} variant-radios input[type="radio"].native-variant`).then(() => {
   document.querySelectorAll(`${uniqueSelector} variant-radios input[type="radio"].native-variant`).forEach(radiobox => {
     radiobox.addEventListener("change", event => {
       const productOptions = document.querySelector(`${uniqueSelector} #product-options`);
       if (productOptions && radiobox.getAttribute('data-variant-price')) {
         productOptions.setAttribute('data-base', radiobox.getAttribute('data-variant-price'));
       }
       reevaluateAllRules(uniqueSelector, optionsData, event);
     });
   });
 });

 // Listen for changes to data-variant-price on sale-price elements
 waitForElmFoodify(`${uniqueSelector} sale-price[data-variant-price]`).then(() => {
   const observer = new MutationObserver((mutations) => {
     mutations.forEach((mutation) => {
       if (mutation.type === 'attributes' && mutation.attributeName === 'data-variant-price') {
         const salePriceElement = mutation.target;
         const newPrice = salePriceElement.getAttribute('data-variant-price');
         const productOptions = document.querySelector(`${uniqueSelector} #product-options`);
         if (productOptions && newPrice) {
           productOptions.setAttribute('data-base', newPrice);
           // Trigger price update
           setTimeout(() => {
             updateOptionsPrice(uniqueSelector);
           }, 100);
         }
       }
     });
   });

   // Observe all sale-price elements for data-variant-price changes
   document.querySelectorAll(`${uniqueSelector} sale-price[data-variant-price]`).forEach(element => {
     observer.observe(element, { attributes: true, attributeFilter: ['data-variant-price'] });
   });
 });
 ////////// End For Native Variants //////////////////




   
     ///////////////////////////////////////////////////////////////
  }

  function fillModal(lineItem, lineItemProperties, lineItemModal) {
    ///////////////////////////////////////////////////////////////
    const properties = lineItemProperties.split('^^^').reduce((acc, cur) => {
        const [key, value] = cur.split(':::');
        const baseKey = key.split('-')[0]; // Extract base key without numeric suffix
        if (key.includes('-')) {
          // If the key includes a '-', it's part of a series (e.g., Sandwich Toppings)
          acc[baseKey] = acc[baseKey] || []; // Initialize as array if not already
          acc[baseKey].push(value);
        } else {
          acc[baseKey] = value;
        }
        return acc;
      }, {});
    Object.entries(properties).forEach(([key, value]) => {
      if(lineItemModal) {
   
        const fieldset = lineItemModal.querySelector(`fieldset[data-id="${key.toLowerCase().replace(" ", "-")}"]`);
        if (!fieldset) return;
      
        if (Array.isArray(value)) {
          value.forEach(val => {
            const normalizedVal = val.trim().toLowerCase();
            const checkboxes = Array.from(fieldset.querySelectorAll('input[type="checkbox"]'));
            const checkbox = checkboxes.find(checkbox => checkbox.value.trim().toLowerCase() === normalizedVal);
            if (checkbox) checkbox.checked = true;
          });
        } 
        else {
          const input = fieldset.querySelector('input, select');
          if (input.tagName.toLowerCase() === 'select') {
            const normalizedValue = value.trim().toLowerCase();
            const options = Array.from(input.options);
            const matchingOption = options.find(option => option.value.trim().toLowerCase() === normalizedValue);
            if (matchingOption) input.value = matchingOption.value;
          } 
          else if (input.type.toLowerCase() === 'checkbox') {
            input.checked = true;
          }
        }
           
      }
    });
    ///////////////////////////////////////////////////////////////
  }

  const formatMoneyFoodify = (cents, format = "") => {
    ///////////////////////////////////////////////////////////////
    if (typeof cents === "string") {
       cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
       return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
       precision = defaultTo(precision, 2);
       thousands = defaultTo(thousands, ",");
       decimal = defaultTo(decimal, ".");
       if (isNaN(number) || number == null) {
          return 0;
       }
       number = (number / 100).toFixed(precision);
       let parts = number.split("."),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : "";
       return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
       case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
       case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
       case "amount_with_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ".");
          break;
       case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
       case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'", ".");
          break;
       case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
       case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
       case "amount_no_decimals_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 0, "'");
          break;
       default:
          value = formatWithDelimiters(cents, 2);
          break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
       return formatString.replace(placeholderRegex, value);
    } 
    else {
       return formatString.replace(placeholderRegex, value);
    }
    ///////////////////////////////////////////////////////////////
  }

  const getExtraCost = (uniqueSelector) => {
    ///////////////////////////////////////////////////////////////
    let selectTotalPrice = 0;
    let inputTotalPrice = 0;
    const fieldsets = document.querySelectorAll(`${uniqueSelector} #product-options fieldset.foodify-fieldset`);
    fieldsets.forEach((fieldset, index) => {
       if (fieldset.dataset.notIncluded == true || fieldset.dataset.notIncluded == 'true') {
          // console.log("skipping extra cost for - ", fieldset)
       } 
       else {
          const selectElements = fieldset.querySelectorAll('#product-options fieldset select.knhjd[data-use="extra-option"]');

          selectElements.forEach((selectElement, index) => {
             if (selectElement.dataset.notIncluded == true || selectElement.dataset.notIncluded == 'true') {
                // console.log("skipping extra cost for - ", selectElement)
             } else {
                const selectedOption = selectElement.options[selectElement.selectedIndex];
                // console.error(selectElement, index)
                const dataPriceString = selectedOption ? selectedOption.getAttribute('data-price')  : '0';
                const dataPrice = parseFloat(dataPriceString);
                if (!isNaN(dataPrice)) {
                   selectTotalPrice += dataPrice;
                } else {
                   console.error(`Invalid data-price value for select ${index + 1}`);
                   return;
                }
             }
          });
          const checkboxElements = fieldset.querySelectorAll('#product-options fieldset input.knhjd[data-use="extra-option"]');
          checkboxElements.forEach((checkboxElement, index) => {
             if (checkboxElement.dataset.notIncluded == true || checkboxElement.dataset.notIncluded == 'true') {
                // console.log("skipping extra cost for - ", checkboxElement)
             } else {
                if (checkboxElement.checked) {
                  // console.log(checkboxElement)
                   const dataPriceString = checkboxElement.getAttribute('data-price');
                   const dataPrice = parseFloat(dataPriceString);
                  // console.log(dataPriceString)

                   if (!isNaN(dataPrice)) {
                      inputTotalPrice += dataPrice;
                   } else {
                      console.error(`Invalid data-price value for selected checkbox ${index + 1}`);
                      return;
                   }
                }
             }
          });
       }
    });
    return selectTotalPrice + inputTotalPrice;
    ///////////////////////////////////////////////////////////////
  }

  function parseWeightFromOptionValue(value) {
    const match = String(value || '').match(/([\d.]+)\s*(lb|lbs|pounds?)\b/i);
    if (!match) return null;
    const weight = parseFloat(match[1]);
    return Number.isFinite(weight) && weight > 0 ? weight : null;
  }

  function isVisibleFoodifyFieldset(fieldset) {
    if (!fieldset) return false;
    if (fieldset.style.display === 'none') return false;
    if (fieldset.dataset.notIncluded === 'true') return false;
    return true;
  }

  function isFoodifyWeightFieldset(fieldset) {
    const name = String(fieldset?.dataset?.categoryName || '').toLowerCase().trim();
    const type = String(fieldset?.dataset?.type || '').toLowerCase();
    return name.startsWith('by weight') || name.startsWith('quantity by weight') || type.includes('by-weight');
  }

  function getSelectedFoodifyWeight(uniqueSelector) {
    const checked = document.querySelectorAll(`${uniqueSelector} #product-options input.knhjd[data-use="extra-option"]:checked`);
    for (const input of checked) {
      const fieldset = input.closest('fieldset');
      if (!isVisibleFoodifyFieldset(fieldset)) continue;
      if (!isFoodifyWeightFieldset(fieldset)) continue;
      const weight = parseWeightFromOptionValue(input.value);
      if (weight != null) return { weight, value: input.value };
    }
    return null;
  }

  function getVariantIdForPrice(uniqueSelector) {
    const variantInput =
      document.querySelector(`${uniqueSelector} form input[name="id"]`) ||
      document.querySelector(`${uniqueSelector} input[name="id"]`);
    const native = document.querySelector(`${uniqueSelector} variant-radios input.native-variant:checked`);
    return variantInput?.value || native?.dataset?.variantId || null;
  }

  function getPricePerLbForSelector(uniqueSelector) {
    const variantId = getVariantIdForPrice(uniqueSelector);
    if (variantId && window.variantSpecs?.[variantId]?.price_lb != null) {
      const value = parseFloat(window.variantSpecs[variantId].price_lb);
      if (Number.isFinite(value)) return value;
    }
    const productEl = document.querySelector(`${uniqueSelector} [data-product-id]`) || document.querySelector('[data-product-id]');
    const productId = productEl?.dataset?.productId;
    if (productId && variantId && window.productsVariantSpecs?.[productId]?.[variantId]?.price_lb != null) {
      const value = parseFloat(window.productsVariantSpecs[productId][variantId].price_lb);
      if (Number.isFinite(value)) return value;
    }
    const fallback = parseFloat(document.querySelector(`${uniqueSelector} #product-options`)?.dataset?.pricePerLb || '');
    return Number.isFinite(fallback) ? fallback : null;
  }
  
  const getPrice = (uniqueSelector) => {
    ///////////////////////////////////////////////////////////////
    try{
    if (typeof window.getActiveFoodifyCustomWeightPrice === 'function') {
      const customWeightPrice = window.getActiveFoodifyCustomWeightPrice(uniqueSelector);
      if (customWeightPrice != null) {
        return customWeightPrice;
      }
    }

    const selectedWeight = getSelectedFoodifyWeight(uniqueSelector);
    const pricePerLb = getPricePerLbForSelector(uniqueSelector);
    if (selectedWeight && pricePerLb != null) {
      return Math.round(selectedWeight.weight * pricePerLb * 100) / 100;
    }

    // Prefer the checked Shopify variant, not a stale hidden sale-price from first load.
    const salePriceElement = document.querySelector(`${uniqueSelector} sale-price[data-variant-price]`);
    let currentVariantPrice = null;
    const selectedVariant = document.querySelector(`${uniqueSelector} variant-radios input[type="radio"].native-variant:checked`);
    if (selectedVariant && selectedVariant.getAttribute('data-variant-price')) {
      currentVariantPrice = selectedVariant.getAttribute('data-variant-price');
    } else if (salePriceElement && !salePriceElement.hidden && salePriceElement.getAttribute('data-variant-price')) {
      currentVariantPrice = salePriceElement.getAttribute('data-variant-price');
    }
    
    // Update the base price if we found a current variant price
    if (currentVariantPrice) {
      const productOptionsElement = document.querySelector(`${uniqueSelector} #product-options`);
      if (productOptionsElement) {
        productOptionsElement.setAttribute('data-base', currentVariantPrice);
      }
    }
    
    const productOptionsElement = document.querySelector(`${uniqueSelector} #product-options`);
    const dataBaseString = productOptionsElement.getAttribute('data-base') || '0';
    const productPrice = parseFloat(dataBaseString);
    if (!isNaN(productPrice)) {
       return productPrice + getExtraCost(uniqueSelector);
    } 
    else {
       console.error('Invalid price value');
    }
    }catch(err){}
    ///////////////////////////////////////////////////////////////
  }

  const updateOptionsPrice = (uniqueSelector) => {
    // return
    setTimeout(()=> {
    ///////////////////////////////////////////////////////////////
    const price = formatMoneyFoodify(getPrice(uniqueSelector) * 100, currencyFormat || "{{amount}}");
    // console.log(price, uniqueSelector)
    const priceElement = document.querySelector(`${uniqueSelector} .product product-info .product-info__price price-list sale-price`);
    if (priceElement) {priceElement.innerHTML = `<span class="sr-only">Sale price</span>${price}`;}
    const priceElement2 = document.querySelector(`${uniqueSelector} price-list sale-price`);
    if (priceElement2) {priceElement2.innerHTML = `<span class="sr-only">Sale price</span>${price}`;}
    const priceElementCart = document.querySelector(`${uniqueSelector} .modal__content price-list sale-price`);
    if (priceElementCart) {priceElementCart.innerHTML = `<span class="sr-only">Sale price</span>${price}`;}
    ///////////////////////////////////////////////////////////////
    }, '100')
  }
  
  const resetInputValues = (targetElement, event) => {
    if (!targetElement) return;
    const inputs = targetElement.matches('input, select') ? [targetElement] : targetElement.querySelectorAll('input, select');
    inputs.forEach(input => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) {
          input.checked = false;
          input.setAttribute('data-last-clicked', 'false');
        }
      } else if (input.tagName.toLowerCase() === 'select') {
        input.selectedIndex = 0;
      } else {
        input.value = '';
      }
    });
  }

  function categoryNameToSlug(name) {
    return name.toLowerCase().split(" ").join("-");
  }

  function findCategoryNameById(optionsData, categoryId) {
    if (!optionsData?.options || !categoryId) return null;
    for (const [name, cat] of Object.entries(optionsData.options)) {
      if (cat.id === categoryId) return name;
    }
    return null;
  }

  function resolveRuleSourceCategory(rule, owningCategoryName, optionsData) {
    if (rule.ruleCategoryId && optionsData) {
      const byId = findCategoryNameById(optionsData, rule.ruleCategoryId);
      if (byId) return byId;
    }
    return owningCategoryName;
  }

  function resolveCategoryFieldset(uniqueSelector, categoryName, categoryId) {
    if (categoryId) {
      const byId = document.querySelector(`${uniqueSelector} fieldset.foodify-fieldset#${CSS.escape(categoryId)}`);
      if (byId) return byId;
    }
    if (categoryName) {
      return document.querySelector(`${uniqueSelector} .foodify-fieldset[data-type="${categoryNameToSlug(categoryName)}"]`);
    }
    return null;
  }

  function getCategorySelection(fieldset, inputType) {
    if (!fieldset) return 'No checked input found';
    const inputTag = inputType === 'checkbox' || inputType === 'image-multi' ? 'checkbox' : 'radio';
    const inputs = fieldset.querySelectorAll(`input[type="${inputTag}"]`);
    let selected = 'No checked input found';
    inputs.forEach(input => {
      if (input.getAttribute('data-last-clicked') === 'true') selected = input.value;
      if (input.checked && selected === 'No checked input found') selected = input.value;
    });
    const anyLastClicked = Array.from(inputs).some(i => i.getAttribute('data-last-clicked') === 'true');
    return anyLastClicked ? selected : (Array.from(inputs).find(i => i.checked)?.value || 'No checked input found');
  }

  function getCategoryCheckboxValues(fieldset) {
    if (!fieldset) return [];
    return Array.from(fieldset.querySelectorAll('input[type="checkbox"]')).filter(i => i.checked).map(i => i.value);
  }

  function getParentChain(categoryName, optionsData) {
    const chain = [];
    let current = categoryName;
    const visited = new Set();
    while (optionsData.options[current]?.parentCategory && !visited.has(optionsData.options[current].parentCategory)) {
      const parent = optionsData.options[current].parentCategory;
      visited.add(parent);
      chain.push(parent);
      current = parent;
    }
    return chain;
  }

  function getEffectiveRules(categoryName, optionsData) {
    const rules = [];
    const seen = new Set();
    [...getParentChain(categoryName, optionsData).reverse(), categoryName].forEach(catName => {
      const cat = optionsData.options[catName];
      if (!cat?.items) return;
      cat.items.forEach(item => {
        if (item.type === 'rule' && item.ruleId && !seen.has(item.ruleId)) {
          seen.add(item.ruleId);
          rules.push({ rule: item, owningCategoryName: catName, categoryType: cat.type, optionLimit: cat.optionLimit || 0 });
        }
      });
    });
    return rules;
  }

  function getEffectiveLimits(category, optionsData, categoryName) {
    let optionLimit = parseInt(category.optionLimit) || 0;
    let hardLimitNumber = parseInt(category.hardLimitNumber) || 0;
    let required = category.required === true || category.required === 'true';
    getParentChain(categoryName, optionsData).forEach(parentName => {
      const parent = optionsData.options[parentName];
      if (!parent) return;
      const pLimit = parseInt(parent.optionLimit) || 0;
      const pHard = parseInt(parent.hardLimitNumber) || 0;
      if (pLimit > optionLimit) optionLimit = pLimit;
      if (pHard > hardLimitNumber) hardLimitNumber = pHard;
      if (parent.required === true || parent.required === 'true') required = true;
    });
    return { optionLimit, hardLimitNumber, required };
  }

  function getCategoriesHiddenByShowRules(optionsData) {
    const hidden = new Set();
    if (!optionsData?.options) return hidden;
    Object.values(optionsData.options).forEach(cat => {
      (cat.items || []).forEach(item => {
        if (item.type === 'rule' && item.action === 'show' && item.ruleFields) {
          item.ruleFields.forEach(field => {
            if (field.name?.includes(' - Category')) hidden.add(field.name.split(' - Category')[0]);
          });
        }
      });
    });
    return hidden;
  }

  const SPECIES_VARIANT_MAP = {
    'Atlantic Salmon': { cubes: 'Atlantic cubes By Quantities ', weight: 'By Weight (atlantic)' },
    'Baby Salmon': { cubes: 'Baby Salmon Cubes By Quantities  ', weight: 'By Weight (baby) ' },
    'Scottish Salmon': { cubes: 'Scottish salmon Cubes By Quantities ', weight: 'By Weight (scottish) ' }
  };

  function getActiveNativeVariant(uniqueSelector) {
    return document.querySelector(`${uniqueSelector} variant-radios input[type="radio"].native-variant:checked`)?.value || null;
  }

  function isSpeciesSpecificWeightCategory(name) {
    const lower = String(name || '').toLowerCase();
    if (!lower.startsWith('by weight')) return false;
    const remainder = lower
      .replace(/^by weight\s*/i, '')
      .replace(/[().,]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return remainder.length > 0;
  }

  function getSpeciesCategories(optionsData) {
    const cubes = [];
    const weights = [];
    if (!optionsData?.options) return { cubes, weights };
    Object.keys(optionsData.options).forEach(name => {
      const lower = name.toLowerCase();
      if (lower.includes('cubes by quantit')) cubes.push(name);
      else if (isSpeciesSpecificWeightCategory(name)) weights.push(name);
    });
    return { cubes, weights };
  }

  function normalizeSpeciesTokens(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/^by weight\s*/i, '')
      .replace(/[().,]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .split(' ')
      .filter((token) => token && token !== 'tuna' && token !== 'salmon');
  }

  function speciesMatchScore(variantName, categoryName) {
    const variantTokens = normalizeSpeciesTokens(variantName);
    const categoryTokens = normalizeSpeciesTokens(categoryName);
    if (!variantTokens.length || !categoryTokens.length) return 0;
    const tokenMatch = (a, b) => a === b || a.startsWith(b) || b.startsWith(a);
    const hits = variantTokens.filter((token) => categoryTokens.some((ct) => tokenMatch(token, ct))).length;
    if (hits === 0 || hits < variantTokens.length) return 0;
    return hits / Math.max(variantTokens.length, categoryTokens.length);
  }

  function findMatchingWeightCategory(nativeVariant, weights) {
    if (!nativeVariant || !weights.length) return null;
    let best = null;
    let bestScore = 0;
    weights.forEach((name) => {
      const score = speciesMatchScore(nativeVariant, name);
      if (score > bestScore) {
        bestScore = score;
        best = name;
      }
    });
    return bestScore > 0 ? best : null;
  }

  function hideFieldset(fieldset) {
    if (!fieldset) return;
    fieldset.style.display = 'none';
    fieldset.dataset.notIncluded = 'true';
    resetInputValues(fieldset);
  }

  function showFieldset(fieldset) {
    if (!fieldset) return;
    fieldset.style.display = 'block';
    fieldset.dataset.notIncluded = 'false';
  }

  function enforceSpeciesExclusivity(optionsData, uniqueSelector) {
    const { cubes, weights } = getSpeciesCategories(optionsData);
    const nativeVariant = getActiveNativeVariant(uniqueSelector);
    const speciesConfig = SPECIES_VARIANT_MAP[nativeVariant];
    if (cubes.length === 0 && weights.length === 0) {
      return;
    }

    if (cubes.length > 0) {
      cubes.forEach(catName => {
        if (!speciesConfig || catName !== speciesConfig.cubes) {
          hideFieldset(resolveCategoryFieldset(uniqueSelector, catName, optionsData.options[catName]?.id));
        }
      });

      weights.forEach(catName => {
        if (!speciesConfig || catName !== speciesConfig.weight) {
          hideFieldset(resolveCategoryFieldset(uniqueSelector, catName, optionsData.options[catName]?.id));
        }
      });

      if (!speciesConfig) return;

      const cubesFieldset = resolveCategoryFieldset(uniqueSelector, speciesConfig.cubes, optionsData.options[speciesConfig.cubes]?.id);
      if (cubesFieldset) showFieldset(cubesFieldset);

      const weightFieldset = resolveCategoryFieldset(uniqueSelector, speciesConfig.weight, optionsData.options[speciesConfig.weight]?.id);
      if (getCategorySelection(cubesFieldset, 'pill') === 'By Weight') {
        if (weightFieldset) showFieldset(weightFieldset);
      } else {
        hideFieldset(weightFieldset);
      }

      if (typeof window.injectFoodifyCustomWeight === 'function') {
        window.injectFoodifyCustomWeight(uniqueSelector, optionsData);
      }
      return;
    }

    const match = findMatchingWeightCategory(nativeVariant, weights);
    weights.forEach((catName) => {
      const fieldset = resolveCategoryFieldset(uniqueSelector, catName, optionsData.options[catName]?.id);
      if (match && catName === match) showFieldset(fieldset);
      else hideFieldset(fieldset);
    });
    Object.keys(optionsData.options).forEach((name) => {
      if (!name.toLowerCase().startsWith('quantity by weight')) return;
      const fieldset = resolveCategoryFieldset(uniqueSelector, name, optionsData.options[name]?.id);
      if (match) hideFieldset(fieldset);
      else showFieldset(fieldset);
    });
    if (typeof window.injectFoodifyCustomWeight === 'function') {
      window.injectFoodifyCustomWeight(uniqueSelector, optionsData);
    }
  }

  window.findActiveFoodifyWeightFieldset = function (uniqueSelector, optionsData) {
    const nativeVariant = getActiveNativeVariant(uniqueSelector);
    const speciesConfig = SPECIES_VARIANT_MAP[nativeVariant];
    let categoryName = null;
    if (speciesConfig && optionsData?.options?.[speciesConfig.weight]) {
      categoryName = speciesConfig.weight;
    } else {
      const { weights } = getSpeciesCategories(optionsData);
      categoryName = findMatchingWeightCategory(nativeVariant, weights);
      if (!categoryName && optionsData?.options) {
        categoryName =
          Object.keys(optionsData.options).find((name) => name.toLowerCase().startsWith('quantity by weight')) ||
          Object.keys(optionsData.options).find((name) => name.toLowerCase() === 'by weight') ||
          null;
      }
    }
    if (!categoryName || !optionsData?.options?.[categoryName]) return null;

    const fieldset = resolveCategoryFieldset(
      uniqueSelector,
      categoryName,
      optionsData.options[categoryName]?.id
    );
    if (!fieldset || fieldset.style.display === 'none' || fieldset.dataset.notIncluded === 'true') {
      return null;
    }
    return fieldset;
  };

  function resetHiddenCategorySelections(uniqueSelector) {
    document.querySelectorAll(`${uniqueSelector} .foodify-fieldset`).forEach(fieldset => {
      if (fieldset.style.display === 'none' || fieldset.dataset.notIncluded === 'true') {
        resetInputValues(fieldset);
      }
    });
  }

  function reevaluateAllRules(uniqueSelector, optionsData, event) {
    Object.keys(optionsData.options).forEach(categoryName => {
      getEffectiveRules(categoryName, optionsData).forEach(({ rule, owningCategoryName, categoryType, optionLimit }) => {
        generateRule(uniqueSelector, owningCategoryName, rule, categoryType, optionLimit, event, optionsData);
      });
    });
    enforceSpeciesExclusivity(optionsData, uniqueSelector);
    resetHiddenCategorySelections(uniqueSelector);
    setTimeout(() => updateOptionsPrice(uniqueSelector), 200);
  }
  
  const generateRule = (uniqueSelector, categoryName, rule, type, limit, event, optionsData) => {
     console.log("🔍 GENERATE RULE CALLED:", {
        categoryName: categoryName,
        ruleType: type,
        ruleId: rule.ruleId,
        action: rule.action,
        firstCondition: rule.firstCondition,
        secondCondition: rule.secondCondition,
        eventTarget: event?.target?.value,
        eventTargetName: event?.target?.name
     });
     
     let { action, ruleFields, conditionLink, firstCondition, secondCondition, ruleId } = rule;
     let conditionMet = false;
     const sourceCategoryName = resolveRuleSourceCategory(rule, categoryName, optionsData);
     const category = sourceCategoryName;
     console.log("📋 Rule source category:", category, "ruleCategoryId:", rule.ruleCategoryId);
     if (Array.isArray(secondCondition)) {
        // NEW FORMAT FOR MULTI VALUE SECOND CONDITION
        //-console.log("NEW FORMAT")
        if (ruleFields) {
           ///////////////////////////////////////////////////////////////
           if (firstCondition != 'limit' && firstCondition != 'total-selected' && !secondCondition.includes('total-selected') && !secondCondition.includes('limit')) {
              ///////////////////////////////////////////////////////////////
              if (type == 'checkbox' || type == 'image-multi') {
                 waitForElmFoodify(`${uniqueSelector} .foodify-fieldset[data-type="${categoryNameToSlug(categoryName)}"]`).then((elm) => {
                    const sourceFieldset = resolveCategoryFieldset(uniqueSelector, sourceCategoryName, rule.ruleCategoryId);
                    setTimeout(() => {}, 1000);
                    const checkedValues = getCategoryCheckboxValues(sourceFieldset);
                    const modifiedSecondCondition = secondCondition.map(item => item.replace('-native-variant', ''));
                    const isSelected = modifiedSecondCondition.some(condition => checkedValues.includes(condition));
                    if (isSelected) {
                       //////////////////////////////////////////////////////////////////
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'block' : 'none';
                             targetFieldset.dataset.notIncluded = action == 'show' ? false : true;
                             if (action != 'show') {
                                resetInputValues(targetFieldset);
                             }
                          }
                          else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'block' : 'none';
                             targetItemInput.dataset.notIncluded = action == 'show' ? false : true;
                             if (action != 'show') targetItemInput.checked = false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                       //////////////////////////////////////////////////////////////////
                    }
                    else {
                       ///////////////////////////////////////////////////////////////
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'none' : 'block';
                             targetFieldset.dataset.notIncluded = action == 'show' ? true : false;
                             if (action == 'show') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          }
                          else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'none' : 'block';
                             targetItemInput.dataset.notIncluded = action == 'show' ? true : false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                       ///////////////////////////////////////////////////////////////
                    }
                 });
              }
              ///////////////////////////////////////////////////////////////
              if (type === 'radio' || type === 'image' || type === 'pill') {
                 const normalizedCategoryName = categoryName.toLowerCase().split(" ").join("-");
                 const fieldsetSelector = `${uniqueSelector} .foodify-fieldset[data-type="${normalizedCategoryName}"]`;
                 waitForElmFoodify(fieldsetSelector).then(() => {
                    setTimeout(() => {
                       //-console.log(secondCondition)
                       if (secondCondition.some(condition => condition.includes("-native-variant"))) {
                          //-console.log("native variant")
                          ////////////// NATIVE VARIANT ///////////////////////////////////
                          const inputs = document.querySelectorAll(`${uniqueSelector} variant-radios input[type="radio"].native-variant`);
                          const checkedValue = [...inputs].find(input => input.checked)?.value || "No checked input found";
                          //-console.log("checkedValue", checkedValue);
                          const modifiedSecondCondition = secondCondition.map(condition => condition.replace("-native-variant", ""));
                          const isSelected = modifiedSecondCondition.includes(checkedValue);
                          //-console.log("isSelected", isSelected);
                          const inCategory = category === event.target.name.replace("properties[", "").replace("]", "");
                          if (isSelected) {
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      if (displayStyle == 'none') {
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                         }
                                      }
                                   }
                                }
                                if (hasCategory) {
                                   targetElement.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                   if (notIncluded) targetElement.checked = false;
                                }
                             });
                          }
                          else {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                const oppositeDisplayStyle = action === 'show' ? 'none' : 'block';
                                if (hasCategory) {
                                   targetElement.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement);
                                      // window.singleHandleChange(event);
                                   }
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement, event);
                                      // window.singleHandleChange(event);
                                   }
                                }
                             });
                          }
                          ////////////// END NATIVE VARIANT ///////////////////////////////
                       }
                       else {
                          //-console.log("not native variant")
                          ////////////// NOT NATIVE VARIANT ///////////////////////////////////
                          const sourceFieldset = resolveCategoryFieldset(uniqueSelector, sourceCategoryName, rule.ruleCategoryId);
                          const actualCheckedValue = getCategorySelection(sourceFieldset, type);
                          console.log("🔎 Checking source category:", sourceCategoryName, "selection:", actualCheckedValue);
                          const isSelected = secondCondition.some(condition => {
                             const cleanCondition = condition.includes('-native-variant') ? condition.replace('-native-variant', '') : condition;
                             return actualCheckedValue === cleanCondition;
                          });
                          console.log("✨ Rule condition met?", isSelected, "for conditions:", secondCondition);
                          const inCategory = category === event.target.name.replace("properties[", "").replace("]", "")
                          // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                          if (isSelected) {
                             console.log("✅ RULE TRIGGERED - Applying action:", action);
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                if (hasCategory) {
                                   console.log("🎨 Setting display for category fieldset:", targetName, "to", displayStyle);
                                   targetElement.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                   if (notIncluded) targetElement.checked = false;
                                }
                             });
                          }
                          else {
                             console.log("❌ RULE NOT TRIGGERED - Condition not met. checkedValue:", actualCheckedValue, "secondCondition:", secondCondition);
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                console.log("🎯 Rule field target (else):", field.name, "selector:", targetSelector, "found:", !!targetElement);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                const oppositeDisplayStyle = action === 'show' ? 'none' : 'block';
                                if (hasCategory) {
                                   console.log("🎨 Setting display for category fieldset (else):", targetName, "to", oppositeDisplayStyle);
                                   targetElement.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement);
                                      // window.singleHandleChange(event);
                                   }
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement, event);
                                      // window.singleHandleChange(event);
                                   }
                                }
                             });
                          }
                          ////////////// END NOT NATIVE VARIANT ///////////////////////////////
                       }
                    }, 50);
                 });
              }
              ///////////////////////////////////////////////////////////////
              if (type == 'select') {
                 waitForElmFoodify(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`).then((elm) => {
                    const fieldset = document.querySelector(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`)
                    setTimeout(() => {}, 1000);
                    // const isSelected = document.querySelector(`${uniqueSelector} select[name="properties[${category}]"]`)?.value === secondCondition;
                    const isSelected = secondCondition.some(condition => {
                       return document.querySelector(`${uniqueSelector} select[name="properties[${category}]"]`)?.value === condition;
                    });
                    if (isSelected) {
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'block' : 'none';
                             targetFieldset.dataset.notIncluded = action == 'show' ? false : true;
                             if (action == 'hide') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          } else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'block' : 'none';
                             targetItemInput.dataset.notIncluded = action == 'show' ? false : true;
                             if (action != 'show') targetItemInput.checked = false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                    }
                    else {
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          let targetElement = document.querySelector(targetSelector);
                          if (field.name.includes(" - Native Variant")) {
                             // targetElement
                          }
                          // variant-radios
                          if (!targetElement) {
                             //-console.log(field.name)
                             //-console.log(field)
                          }
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'none' : 'block';
                             targetFieldset.dataset.notIncluded = action == 'show' ? true : false;
                             if (action == 'show') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          } else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'none' : 'block';
                             targetItemInput.dataset.notIncluded = action == 'show' ? true : false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                    }
                 });
              }
              ///////////////////////////////////////////////////////////////
           }
           ///////////////////////////////////////////////////////////////
           if (firstCondition == 'limit' || firstCondition == 'total-selected' || secondCondition.includes('total-selected') || secondCondition.includes('limit')) {
              ///////////////////////////////////////////////////////////////
              const processRuleFields = (isConditionMet) => {
                 ruleFields.forEach(field => {
                    const hasCategory = field.name.includes(" - Category");
                    const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                    const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                    const targetElement = document.querySelector(targetSelector);
                    if (hasCategory) {
                       const targetFieldset = targetElement;
                       if (targetFieldset) {
                          targetFieldset.style.display = isConditionMet ? (action == 'show' ? 'block' : 'none') : (action == 'hide' ? 'block' : 'none');
                          targetFieldset.dataset.notIncluded = isConditionMet.toString() == 'true' ? 'false' : 'true';
                          if (action == 'show') {
                             resetInputValues(targetFieldset);
                             // window.singleHandleChange(event)
                          }
                       }
                    }
                    else {
                       const targetItemInput = targetElement;
                       const targetItemParent = targetItemInput.parentNode;
                       targetItemInput.dataset.notIncluded = isConditionMet.toString() == 'true' ? 'false' : 'true';
                       targetItemParent.style.display = isConditionMet ? (action == 'show' ? 'block' : 'none') : (action == 'hide' ? 'block' : 'none');
                    }
                 });
              };
              ///////////////////////////////////////////////////////////////
              const checkAndProcessCondition = (condition, category) => {
                 const grabTotalSelectedInCategory = document.querySelectorAll(`${uniqueSelector} .foodify-fieldset[data-type="${category.toLowerCase().split(" ").join("-")}"] input[type="checkbox"]`);
                 const totalSelectedCount = grabTotalSelectedInCategory ? Array.from(grabTotalSelectedInCategory).filter(item => item.checked).length : 0;
                 let isConditionMet = false;
                 if (firstCondition === 'limit' && secondCondition.includes('total-selected')) {
                    if (condition === 'greater') isConditionMet = (Number(limit) > totalSelectedCount);
                    else if (condition === 'equal') isConditionMet = (totalSelectedCount === Number(limit));
                    else if (condition === 'less') isConditionMet = (Number(limit) < totalSelectedCount);
                    processRuleFields(isConditionMet);
                 }
              };
              ///////////////////////////////////////////////////////////////
              checkAndProcessCondition(conditionLink, category);
           }
           ///////////////////////////////////////////////////////////////
           setTimeout(() => {
              updateOptionsPrice(uniqueSelector);
           }, 200);
        }
     }
     else {
        // IF USING OLD FORMAT FOR SINGLE VALUE SECOND CONDITION
        //-console.log("OLD FORMAT")
        if (ruleFields) {
           ///////////////////////////////////////////////////////////////
           if (firstCondition != 'limit' && firstCondition != 'total-selected' && secondCondition != 'total-selected' && secondCondition != 'limit') {
              ///////////////////////////////////////////////////////////////
              if (type == 'checkbox' || type == 'image-multi') {
                 waitForElmFoodify(`${uniqueSelector} .foodify-fieldset[data-type="${categoryNameToSlug(categoryName)}"]`).then((elm) => {
                    const sourceFieldset = resolveCategoryFieldset(uniqueSelector, sourceCategoryName, rule.ruleCategoryId);
                    setTimeout(() => {}, 1000);
                    const checkedValues = getCategoryCheckboxValues(sourceFieldset);
                    const isSelected = checkedValues.includes(secondCondition);
                    if (isSelected) {
                       //////////////////////////////////////////////////////////////////
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'block' : 'none';
                             targetFieldset.dataset.notIncluded = action == 'show' ? false : true;
                             if (action != 'show') {
                                resetInputValues(targetFieldset);
                             }
                          }
                          else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'block' : 'none';
                             targetItemInput.dataset.notIncluded = action == 'show' ? false : true;
                             if (action != 'show') targetItemInput.checked = false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                       //////////////////////////////////////////////////////////////////
                    }
                    else {
                       ///////////////////////////////////////////////////////////////
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'none' : 'block';
                             targetFieldset.dataset.notIncluded = action == 'show' ? true : false;
                             if (action == 'show') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          }
                          else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'none' : 'block';
                             targetItemInput.dataset.notIncluded = action == 'show' ? true : false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                       ///////////////////////////////////////////////////////////////
                    }
                 });
              }
              ///////////////////////////////////////////////////////////////
              if (type === 'radio' || type === 'image' || type === 'pill') {
                 const normalizedCategoryName = categoryName.toLowerCase().split(" ").join("-");
                 const fieldsetSelector = `${uniqueSelector} .foodify-fieldset[data-type="${normalizedCategoryName}"]`;
                 waitForElmFoodify(fieldsetSelector).then(() => {
                    setTimeout(() => {
                       if (secondCondition.includes("-native-variant")) {
                          //-console.log("native variant")
                          ////////////// NATIVE VARIANT ///////////////////////////////////
                          // const fieldset = document.querySelector(fieldsetSelector);
                          const inputs = document.querySelectorAll(`${uniqueSelector} variant-radios input[type="radio"].native-variant `); //[name="properties[${category}]"]
                          // console.log("inputs", inputs)
                          const checkedValue = [...inputs].find(input => input.checked)?.value || "No checked input found";
                          //-console.log("checkedValue", checkedValue)
                          const getCheckedValue = (inputs) => {
                             let dataLastClickedValue = 'No checked input found';
                             inputs.forEach(input => {
                                if (input.type.toLowerCase() === 'radio') {
                                   const dataLastClicked = input.getAttribute('data-last-clicked');
                                   if (dataLastClicked === 'true') {
                                      dataLastClickedValue = input.value;
                                   }
                                   if (input.checked && dataLastClickedValue === '') {
                                      dataLastClickedValue = input.value;
                                   }
                                }
                             });
                             let allDataLastClickedFalse = true;
                             inputs.forEach(input => {
                                const dataLastClicked = input.getAttribute('data-last-clicked');
                                if (dataLastClicked === 'true') {
                                   allDataLastClickedFalse = false;
                                }
                             });
                             return allDataLastClickedFalse ? 'No checked input found' : dataLastClickedValue;
                          };
                          const isSelected = checkedValue === secondCondition.replace("-native-variant", "");
                          //-console.log(isSelected)
                          const inCategory = category === event.target.name.replace("properties[", "").replace("]", "")
                          // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                          if (isSelected) {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                if (hasCategory) {
                                   targetElement.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                } else {
                                   //-console.log("xxxxxxxxx")
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                   if (notIncluded) targetElement.checked = false;
                                }
                             });
                          }
                          else {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                            //-console.log(checkedValue)
                                            //-console.log(field.name)
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                const oppositeDisplayStyle = action === 'show' ? 'none' : 'block';
                                if (hasCategory) {
                                   targetElement.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement);
                                      // window.singleHandleChange(event);
                                   }
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement, event);
                                      // window.singleHandleChange(event);
                                   }
                                }
                             });
                          }
                          ////////////// END NATIVE VARIANT ///////////////////////////////
                       }
                       else {
                          ////////////// NOT NATIVE VARIANT ///////////////////////////////////
                          const sourceFieldset = resolveCategoryFieldset(uniqueSelector, sourceCategoryName, rule.ruleCategoryId);
                          const actualCheckedValue = getCategorySelection(sourceFieldset, type);
                          const isSelected = actualCheckedValue === secondCondition;
                          const inCategory = category === event.target.name.replace("properties[", "").replace("]", "")
                          // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                          if (isSelected) {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                            //-console.log(checkedValue)
                                            //-console.log(field.name)
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                if (hasCategory) {
                                   targetElement.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                   if (notIncluded) targetElement.checked = false;
                                }
                             });
                          }
                          else {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                            //-console.log(checkedValue)
                                            //-console.log(field.name)
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                const oppositeDisplayStyle = action === 'show' ? 'none' : 'block';
                                if (hasCategory) {
                                   targetElement.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement);
                                      // window.singleHandleChange(event);
                                   }
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement, event);
                                      // window.singleHandleChange(event);
                                   }
                                }
                             });
                          }
                          ////////////// END NOT NATIVE VARIANT ///////////////////////////////
                       }
                    }, 50);
                 });
              }
              ///////////////////////////////////////////////////////////////
              if (type == 'select') {
                 waitForElmFoodify(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`).then((elm) => {
                    const fieldset = document.querySelector(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`)
                    setTimeout(() => {}, 1000);
                    const isSelected = document.querySelector(`${uniqueSelector} select[name="properties[${category}]"]`)?.value === secondCondition;
                    if (isSelected) {
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'block' : 'none';
                             targetFieldset.dataset.notIncluded = action == 'show' ? false : true;
                             if (action == 'hide') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          } else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'block' : 'none';
                             targetItemInput.dataset.notIncluded = action == 'show' ? false : true;
                             if (action != 'show') targetItemInput.checked = false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                    }
                    else {
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          let targetElement = document.querySelector(targetSelector);
                          if (field.name.includes(" - Native Variant")) {
                             // targetElement
                          }
                          if (!targetElement) {
                             //-console.log(field.name)
                             //-console.log(field)
                          }
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'none' : 'block';
                             targetFieldset.dataset.notIncluded = action == 'show' ? true : false;
                             if (action == 'show') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          } else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'none' : 'block';
                             targetItemInput.dataset.notIncluded = action == 'show' ? true : false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                    }
                 });
              }
              ///////////////////////////////////////////////////////////////
           }
           ///////////////////////////////////////////////////////////////
           if (firstCondition == 'limit' || firstCondition == 'total-selected' || secondCondition == 'total-selected' || secondCondition == 'limit') {
              ///////////////////////////////////////////////////////////////
              const processRuleFields = (isConditionMet) => {
                 ruleFields.forEach(field => {
                    const hasCategory = field.name.includes(" - Category");
                    const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                    const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                    const targetElement = document.querySelector(targetSelector);
                    if (hasCategory) {
                       const targetFieldset = targetElement;
                       if (targetFieldset) {
                          targetFieldset.style.display = isConditionMet ? (action == 'show' ? 'block' : 'none') : (action == 'hide' ? 'block' : 'none');
                          targetFieldset.dataset.notIncluded = isConditionMet.toString() == 'true' ? 'false' : 'true';
                          if (action == 'show') {
                             resetInputValues(targetFieldset);
                             // window.singleHandleChange(event)
                          }
                       }
                    }
                    else {
                       const targetItemInput = targetElement;
                       const targetItemParent = targetItemInput.parentNode;
                       targetItemInput.dataset.notIncluded = isConditionMet.toString() == 'true' ? 'false' : 'true';
                       targetItemParent.style.display = isConditionMet ? (action == 'show' ? 'block' : 'none') : (action == 'hide' ? 'block' : 'none');
                    }
                 });
              };
              ///////////////////////////////////////////////////////////////
              const checkAndProcessCondition = (condition, category) => {
                 const grabTotalSelectedInCategory = document.querySelectorAll(`${uniqueSelector} .foodify-fieldset[data-type="${category.toLowerCase().split(" ").join("-")}"] input[type="checkbox"]`);
                 const totalSelectedCount = grabTotalSelectedInCategory ? Array.from(grabTotalSelectedInCategory).filter(item => item.checked).length : 0;
                 let isConditionMet = false;
                 if (firstCondition === 'limit' && secondCondition === 'total-selected') {
                    if (condition === 'greater') isConditionMet = (Number(limit) > totalSelectedCount);
                    else if (condition === 'equal') isConditionMet = (totalSelectedCount === Number(limit));
                    else if (condition === 'less') isConditionMet = (Number(limit) < totalSelectedCount);
                    processRuleFields(isConditionMet);
                 }
              };
              ///////////////////////////////////////////////////////////////
              checkAndProcessCondition(conditionLink, category);
           }
           ///////////////////////////////////////////////////////////////
           setTimeout(() => {
              updateOptionsPrice(uniqueSelector);
           }, 200);
        }
     }
  }
    
  function dispatchFirstInputChange(uniqueSelector, optionsData) {
    waitForElmFoodify(`${uniqueSelector} #product-options .product-option select, #product-options .product-option input`).then((elm) => {
        elm.dispatchEvent(new Event('change', { bubbles: true }));
    });
    waitForElmFoodify(`${uniqueSelector} #product-options .product-option select, #product-options .product-option input[type="radio"]`).then((elm) => {
        elm.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (optionsData) {
      waitForElmFoodify(`${uniqueSelector} variant-radios input[type="radio"].native-variant`).then(() => {
        reevaluateAllRules(uniqueSelector, optionsData, { target: document.querySelector(`${uniqueSelector} #product-options`) });
      });
    }
  }
  
  /*  Mass Work  */
  function foodifyInitialize(storeData, forMultiple = false, uniqueSelector = '', singleProductData) {
       ///////////////////////////////////////////////////////////////
       //-console.log("load foodify")
    
       let currentProductSKU = forMultiple ? '' : ''
       let currentProductId = forMultiple ? singleProductData.productId : CFG.productId;
       let currentProductTitle = forMultiple ? singleProductData.productTitle : CFG.productTitle;
       let currentLineItemKey = forMultiple ? singleProductData.lineItemKey : ''
       const dataLine = {};
       let findSandwichById = (storeData, productId) => {
          for (let store of storeData) {
             if (store.sandwiches && store.sandwiches.length > 0) {
                let foundSandwich = store.sandwiches.find(sandwich => sandwich.id === productId);
                if (foundSandwich) return foundSandwich;
             }
          }
          return null;
       };
       if(forMultiple) {
           runParams();
       }
       else {
          if (window.hasSandwich) {
            runParams();
         }
       }
       
       function convertToURLParams(inputString) {
          return (inputString.split('+').join('%2B').replaceAll(' ', '+'));
       }
    
       function pushParameter(params) {
          const currentURL = new URL(window.location.href);
          currentURL.search = "";
          currentURL.search = `?${params}`;
          if(window.location.href.includes("/product")){
          history.replaceState({}, "", currentURL.toString());
          }
       }

       function runParams() {
          waitForElmFoodify(`${uniqueSelector} #product-options`).then((targetElement) => {
             waitForElmFoodify(`${uniqueSelector} #product-options input`).then((iElement) => {
                waitForElmFoodify(`${uniqueSelector} #product-options .product-option`).then((pElement) => {
                   selectionTracker(targetElement);
                });
             });
             selectionApplier(targetElement);
             setTimeout(() => {
                const firstCheckbox = targetElement.querySelector(`${uniqueSelector} #product-options .product-option input[type="checkbox"]`);
                if (firstCheckbox) {
                   const currentCheckedState = firstCheckbox.checked;
                   firstCheckbox.checked = !currentCheckedState;
                   firstCheckbox.checked = currentCheckedState;
                   const customChangeEvent = new Event("change", {
                      bubbles: true,
                   });
                   firstCheckbox.dispatchEvent(customChangeEvent);
                }
             }, 00);
          });
       }
    
       const getProductOptions = () => {
           const optionsData = [];
           document.querySelectorAll(`${uniqueSelector} .product-option`).forEach(fieldset => {
              const category = fieldset.getAttribute('data-type');
              fieldset.querySelectorAll('input:not(:disabled), select:not(:disabled)').forEach(element => {
                  if (element.tagName.toLowerCase() === 'select' && element.value === '') return;
                  const name = element.tagName.toLowerCase() === 'select' ? element.options[element.selectedIndex]?.text : element.value;
                  const optionId = element.id;
                  let selected;
                  if (element.type.toLowerCase() === 'radio') {
                  const dataLastClicked = element.getAttribute('data-last-clicked');
                  selected = dataLastClicked !== null ? dataLastClicked === 'true' : element.checked;
                  } 
                  else {
                  selected = element.tagName.toLowerCase() === 'select' ? element.value !== '' : element.checked;
                  }
                  const price = element.dataset.price;
                  optionsData.push({ category, name, optionId, selected, price });
              });
          });
           return optionsData;
        };
    
       function selectionTracker(targetElement) {
          const plWrapper = targetElement.querySelectorAll(".product-option");
          const handleChangeOthers = (event, label) => {
             if (event.detail && event.detail.exit && event.detail.exit === true) {
                return; 
             }
             let newString = "";
             plWrapper.forEach((wrapper) => {
                const label = wrapper.dataset.type;
                dataLine[label] = Array.isArray(dataLine[label]) ? dataLine[label] : [];
                const selects = wrapper.querySelector("select");
                const checkboxes = wrapper.querySelectorAll("input[type='checkbox']");
                const radioboxes = wrapper.querySelectorAll("input[type='radio']");
                newString += label + "=";
                if (selects) {
                   dataLine[label] = selects.value.trim();
                   newString += dataLine[label];
                }
                if (checkboxes.length > 0) {
                   checkboxes.forEach(checkbox => {
                      const valueToAdd = String(checkbox.value.trim());
                      if (checkbox.checked) {
                         if (!dataLine[label].includes(valueToAdd)) {
                            dataLine[label].push(valueToAdd);
                         }
                      } else {
                         dataLine[label] = dataLine[label].filter(item => item !== valueToAdd);
                      }
                   });
                }
             });
             updateOptionsPrice(uniqueSelector);
             setTimeout(() => {
                const options = getProductOptions();
                let groupedOptions = options.reduce((acc, { category, name, selected }) => {
                   if (selected) {
                      if (!acc[category]) {
                         acc[category] = [];
                      }
                      acc[category].push(name);
                   }
                   return acc;
                }, {});
                let urlParams = Object.entries(groupedOptions).map(([key, value]) => {
                   return `${key}=${value.join('_')}`;
                }).join('&');
                urlParams = `${urlParams}`;
                // console.log("p",urlParams);
                const doneParam = convertToURLParams(urlParams);
                // decodeParams(doneParam)
                if (!window.location.href.includes("/cart")) { pushParameter(doneParam) }
             }, 250)
          }
          const handleChangeRadio = (event) => {
             let newString = "";
             plWrapper.forEach((wrapper) => {
                ///////////////////////////////////////////////////////////////
                const label = wrapper.dataset.type;
                dataLine[label] = Array.isArray(dataLine[label]) ? dataLine[label] : [];
                const selects = wrapper.querySelector("select");
                const checkboxes = wrapper.querySelectorAll("input[type='checkbox']");
                const radioboxes = wrapper.querySelectorAll("input[type='radio']");
                newString += label + "=";
                if (radioboxes.length > 0) {
                   radioboxes.forEach(radiobox => {
                      const valueToAdd = String(radiobox.value.trim());
    
                      if (radiobox.value == event.target.value) {
    
                         if (!dataLine[label].includes(valueToAdd)) {
    
                            dataLine[label].push(valueToAdd); 
    
                         } else {
                            const nameAttribute = event.target.name; 
                            const startIndex = nameAttribute.indexOf('[') + 1;
                            const endIndex = nameAttribute.indexOf(']');
                            const extractedWord = nameAttribute.substring(startIndex, endIndex);
    
                            if (label.toLowerCase() == extractedWord.toLowerCase()) {
    
                               dataLine[label] = dataLine[label].filter(item => item !== valueToAdd);
    
                            }
    
                         }
                      } else {
                         const nameAttribute = event.target.name; 
                         const startIndex = nameAttribute.indexOf('[') + 1;
                         const endIndex = nameAttribute.indexOf(']');
                         const extractedWord = nameAttribute.substring(startIndex, endIndex);
    
                         if (label.toLowerCase() == extractedWord.toLowerCase()) {
                            dataLine[label] = dataLine[label].filter(item => item !== valueToAdd);
                         }
    
                      }
    
                   });
                }
                ///////////////////////////////////////////////////////////////
             });
             updateOptionsPrice(uniqueSelector);
             setTimeout(() => {
              const options = getProductOptions();
              let groupedOptions = options.reduce((acc, { category, name, selected }) => {
                 if (selected) {
                    if (!acc[category]) {
                       acc[category] = [];
                    }
                    acc[category].push(name);
                 }
                 return acc;
              }, {});
              let urlParams = Object.entries(groupedOptions).map(([key, value]) => {
                 return `${key}=${value.join('_')}`;
              }).join('&');
              urlParams = `${urlParams}`;
              // console.log(urlParams);
              const doneParam = convertToURLParams(urlParams);
              // decodeParams(doneParam)
              if (!window.location.href.includes("/cart")) { pushParameter(doneParam) }
           }, 250)
          }
          if (targetElement) {
             plWrapper.forEach((wrapper) => {
                ///////////////////////////////////////////////////////////////
                const label = wrapper.dataset.type;
                dataLine[label] = {};
                waitForElmFoodify(`${uniqueSelector} #product-options .product-option select`).then((dkm) => {
                   const selects = wrapper.querySelector("select");
                   if (selects) { selects.addEventListener("change", (event) => handleChangeOthers(event, label)); }
                });
                waitForElmFoodify(`${uniqueSelector} #product-options .product-option input[type="checkbox"]`).then((dkm) => {
                   const checkboxes = wrapper.querySelectorAll("input[type='checkbox']");
                   if (checkboxes) { checkboxes.forEach((checkbox) => checkbox.addEventListener("change", (event) => handleChangeOthers(event, label))); }
                });
                waitForElmFoodify(`${uniqueSelector} #product-options .product-option input[type="radio"]`).then((dkm) => {
                   const radioboxes = wrapper.querySelectorAll("input[type='radio']");
                   if (radioboxes) { radioboxes.forEach((radiobox) => radiobox.addEventListener("change", (event) => handleChangeRadio(event, label))); }
                });
                ///////////////////////////////////////////////////////////////
             });
          }
       }
    
       function selectionApplier(targetElement) {
          function decodeParams(params) {
            if(params){
             let uri = params.replaceAll("+", " ").split('%2B').join('+')
             return decodeURIComponent(uri);
            }
            else{
              return ''
             }
          }
          function extractValueFromParams(params, label) {
            const entries = params.split('&').map(param => {
              const [key, value] = param.split('=');
              return { key: decodeURIComponent(key), value: decodeURIComponent(value) };
            });
            const found = entries.find(entry => entry.key === label);
            return found ? found.value : null;
          }
          function extractValuesFromParams(params, label) {
            const entries = params.split('&').map(param => {
              const [key, value] = param.split('=');
              return { key: decodeURIComponent(key), value: decodeURIComponent(value) };
            });
            const found = entries.find(entry => entry.key === label);
            return found ? found.value.split('_') : [];
          }
          const urlString = window.location.href;
    
          const urlParams = urlString.split('?')[1];
          const decodedParams = decodeParams(urlParams);
          const pplrWrappers = targetElement.querySelectorAll(".product-option");
          pplrWrappers.forEach(wrapper => {
             const label = wrapper.dataset.type;
             const value = extractValueFromParams(decodedParams, label);
             if (value && wrapper.querySelector("select")) {
                wrapper.querySelector("select").value = value;
             }
             const values = extractValuesFromParams(decodedParams, label);
             if (values) {
                const checkboxes = wrapper.querySelectorAll('[type="checkbox"]');
                checkboxes.forEach(checkbox => {
                   checkbox.checked = values.includes(checkbox.value);
                });
    
                const radioboxes = wrapper.querySelectorAll('[type="radio"]');
                radioboxes.forEach(radiobox => {
                   radiobox.checked = values.includes(radiobox.value);
                  if(values.includes(radiobox.value)){
                    radiobox.setAttribute("data-last-clicked", "true")
                  }else {
                    radiobox.setAttribute("data-last-clicked", "false")
                  }
                });
             }
          });
          updateOptionsPrice(uniqueSelector);
       }

       function checkAnySelected(form){
         const productOptions = document.getElementById('product-options');
         if (!productOptions || !productOptions.hasChildNodes()) return false;
         const visibleFieldsets = productOptions.querySelectorAll('fieldset.foodify-fieldset');
         let hasUnselectedRequired = false;
         visibleFieldsets.forEach(fieldset => {
           if (fieldset.style.display === 'none') return;
           if (fieldset.dataset.notIncluded === 'true') return;
           if (!fieldset.dataset.required) return;
           const inputs = fieldset.querySelectorAll('input[type="checkbox"], input[type="radio"]');
           const selects = fieldset.querySelectorAll('select');
           if (inputs.length === 0 && selects.length === 0) return;
           if (inputs.length > 0) {
             const hasChecked = Array.from(inputs).some(input => input.checked);
             if (!hasChecked) hasUnselectedRequired = true;
           }
           if (selects.length > 0) {
             const hasSelected = Array.from(selects).some(s => s.value !== '');
             if (!hasSelected) hasUnselectedRequired = true;
           }
         });
         return hasUnselectedRequired;
      }

      function checkAnySelectedMultiple(form, uniqueSelector){
         const productOptions = form.querySelector('#product-options');
         if (!productOptions || !productOptions.hasChildNodes()) return false;
         const visibleFieldsets = productOptions.querySelectorAll('fieldset.foodify-fieldset');
         let hasUnselectedRequired = false;
         visibleFieldsets.forEach(fieldset => {
           if (fieldset.style.display === 'none') return;
           if (fieldset.dataset.notIncluded === 'true') return;
           if (!fieldset.dataset.required) return;
           const inputs = fieldset.querySelectorAll('input[type="checkbox"], input[type="radio"]');
           const selects = fieldset.querySelectorAll('select');
           if (inputs.length === 0 && selects.length === 0) return;
           if (inputs.length > 0) {
             const hasChecked = Array.from(inputs).some(input => input.checked);
             if (!hasChecked) hasUnselectedRequired = true;
           }
           if (selects.length > 0) {
             const hasSelected = Array.from(selects).some(s => s.value !== '');
             if (!hasSelected) hasUnselectedRequired = true;
           }
         });
         return hasUnselectedRequired;
      }

      function mergeCustomWeightFormValues(formValues) {
        const customWeightProps = window.getFoodifyCustomWeightProperties?.(uniqueSelector);
        if (customWeightProps) {
          formValues['properties[weight]'] = customWeightProps.weight;
          formValues['properties[price_per_pound]'] = customWeightProps.price_per_pound;
        }
      }

       function addToCartInitializer(){
         ///////////////////////////////////////////////////////////////
         const addToCartForm = document.querySelector('form[is="product-form"]');
         const atcBtn = document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"]');
         const atcText = document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"] span');
         const loadingSpinner = document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"] .loading__spinner');
         
         if (addToCartForm && window.hasSandwich) { // && false
            addToCartForm.addEventListener('submit', function(event) {
              // console.log("sub")
               ///////////////////////////////////////////////////////////////
               event.stopPropagation();
               event.preventDefault();

               if (requireLoginFoodify) if (!window.customerLoggedIn) { try { MicroModal.close(); document.querySelectorAll('.modal.is-open').forEach(el => el.classList.remove('is-open')); } catch (err) { console.error(err); } document.body.style.overflow = 'auto'; try { document.querySelector('#deliverify-main').style.pointerEvents = "none"; } catch (err) { console.error(err); } try { MicroModal.show('modal-login'); } catch (err) { console.error(err); } try { const submitButtons = Array.from(document.querySelectorAll(`${uniqueSelector} button[type="submit"]`)); submitButtons.forEach((submitButton) => { submitButton.removeAttribute("disabled"); submitButton.setAttribute("aria-busy", "false"); }); return; } catch (err) { console.error(err); } }
    
               /*  return  */
               /*  console.log("continue")  */
              
              const price = getPrice(uniqueSelector);
              
              const form = document.querySelector('form[action="/cart/add"][data-type="add-to-cart-form"][is="product-form"]');
              const formData1 = new FormData(form);
              
               if(checkAnySelected(form)){
                  const errorMessage = document.createElement('div');
                  const buttons = form.querySelector('.product-form__buttons');
                  if (!buttons) return;
                  Object.assign(errorMessage.style, { color: 'red', marginTop: '-20px', paddingBottom: '10px', display: 'block' });
                  form.insertBefore(errorMessage, buttons);
                  errorMessage.textContent = 'Please select an option.';
                     
                  setTimeout(() => {
                    const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
                    submitButtons.forEach((submitButton) => {
                       submitButton.removeAttribute("disabled");
                       submitButton.removeAttribute("aria-busy");
                    });
                    if (loadingSpinner) loadingSpinner.classList.add('hidden');
                    if (atcText) atcText.style.opacity = "1";
                  }, 500);
                  setTimeout(() => {
                    errorMessage.style.display = 'none'; 
                  }, 1500);
                  return
                }

               if (typeof window.validateFoodifyCustomWeight === 'function') {
                 const customWeightValidation = window.validateFoodifyCustomWeight(uniqueSelector);
                 if (!customWeightValidation.valid) {
                   const errorMessage = document.createElement('div');
                   const buttons = form.querySelector('.product-form__buttons');
                   if (!buttons) return;
                   Object.assign(errorMessage.style, { color: 'red', marginTop: '-20px', paddingBottom: '10px', display: 'block' });
                   form.insertBefore(errorMessage, buttons);
                   errorMessage.textContent = customWeightValidation.message || 'Enter a valid weight.';
                   setTimeout(() => {
                     const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
                     submitButtons.forEach((submitButton) => {
                       submitButton.removeAttribute("disabled");
                       submitButton.removeAttribute("aria-busy");
                     });
                   }, 500);
                   setTimeout(() => {
                     errorMessage.style.display = 'none';
                   }, 1500);
                   return;
                 }
               }
 
               if (!onAddtoCart(form)) {return}
               createSandwich(formData1, form, price, atcBtn, atcText, loadingSpinner)
               ///////////////////////////////////////////////////////////////
            }); // end submit

            // buy-buttons.liquid renders the button disabled until this handler exists.
            if (atcBtn && atcBtn.hasAttribute('data-options-pending')) {
              atcBtn.removeAttribute('data-options-pending');
              atcBtn.disabled = false;
            }
         }

         async function createSandwich(formData1, form, price) {
           ///////////////////////////////////////////////////////////////
           //-console.log("create sandwich"); console.log(form.id.value); console.log(formData1); console.log(window.currentVariant?.variant_id ?? formValues.id);

           function getFormValues(form) {
            const inputs = form.querySelectorAll('input, select, textarea');
            const values = {};
            inputs.forEach(input => {
              if (input.type === "checkbox" || input.type === "radio") {
                if (input.checked) {
                  values[input.name] = input.value;
                }
              } else {
                values[input.name] = input.value;
              }
            });
            return values;
          }
           if (typeof window.syncFoodifyCustomWeightUi === 'function') {
             window.syncFoodifyCustomWeightUi(uniqueSelector);
           }
           const formValues = getFormValues(form);
           mergeCustomWeightFormValues(formValues);

           // TEST: Skip Gadget API and add directly to cart with _price
           console.log("TEST MODE: Adding to cart with _price instead of Gadget API");
           
           ///////////////////////////////////////////////////////////////
           // The item is already in the cart when this runs — reflect it
           // immediately instead of the old staged Processing../Added waits.
           setTimeout(() => {
             setTimeout(() => {
               atcBtn.removeAttribute('aria-busy'); 
               atcText.style.opacity = '1'
               atcText.textContent = 'Added'
               atcText.style.setProperty('color', `${highlight_text_color}`, 'important');
               atcBtn.style.setProperty('background', `${highlight_bg_color}`, 'important');
             }, '0')
             
             setTimeout(() => {
               atcBtn.disabled = false;
               atcText.textContent = 'Add To Cart'
               if(useArrow) {
                 atcText.style.setProperty('color', `${highlight_text_color}`, 'important');
                 atcBtn.style.setProperty('background', `${highlight_bg_color}`, 'important');
               }else {
                 atcText.style.setProperty('color', `${normal_text_color}`, 'important');
                 atcBtn.style.setProperty('background', `${normal_bg_color}`, 'important');
               }
             }, '1500')
             
             afterAddtoCart(form);
            }, 0);
           ///////////////////////////////////////////////////////////////
      
           try {
              ///////////////////////////////////////////////////////////////
              // TEST: Add directly to cart with custom price
              const variantId = window.currentVariant?.variant_id ?? formValues.id;
              
              // Get quantity from form (default to 1 if not found)
              const quantity = parseInt(formValues.quantity) || 1;
              
              // Add cart item with custom price
              const cartItem = {
                id: variantId,
                quantity: quantity,
                price: price, // The updateShopifyCart function will automatically add this as _price property
                properties: {} // Initialize properties object
              };
              
              // Add all form properties to the cart item
              Object.keys(formValues).forEach(key => {
                if (key !== 'id' && formValues[key]) {
                  cartItem.properties[key] = formValues[key];
                }
              });
              
              console.log("Adding to cart with custom price:", cartItem);
              
              // Use the existing updateShopifyCart function with custom price
              updateShopifyCart([cartItem], formValues, form);
              
              form.setAttribute('data-form-ready', 'true');
              timer.stop('create');
              
              // COMMENTED OUT: Original Gadget API call
              /*
              const response = await fetch(url, {
                  method: 'POST',
                  headers: {
                     'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(payload),
               });
              const data = await response.json();
              // const variantId = data.variantId.id.split("/").pop();
             // Jays routes returns just the actual variant id
             const variantId = data.variantId;
             const originalVariantId = data.parentVariantId;
              form.querySelector('input[name="id"]').value = variantId;
              form.setAttribute('data-form-ready', 'true');
              timer.stop('create')

             // Jays new add to cart function -> found in simple-add-to-cart.js
            updateShopifyCart([{id: variantId, quantity: 1, price: price}], formValues, form);

// console.log("Reseting current variant id to originalVariantId", originalVariantId);
             form.querySelector('input[name="id"]').value = originalVariantId;
// console.log("Reseting to originalVariantId completed", form.querySelector('input[name="id"]').value);                 


              // setTimeout(() => {
              //     addToCart2(form, data, variantId, currentProductId)
              //  }, 50); //" SET BACK"
              */
              ///////////////////////////////////////////////////////////////
            } 
           catch (error) {
               console.error('Error during cart add:', error);
               afterAddtoCart(form)
            }
           ///////////////////////////////////////////////////////////////
         }

         function onAddtoCart(form) {
            ///////////////////////////////////////////////////////////////
            if (form.getAttribute('data-form-ready') === "true") {
               // return;
            }
            if (loadingSpinner) {
               // loadingSpinner.classList.remove('hidden');
              if(document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"]')){
                document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"]').disabled = 'true'
                document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"]').setAttribute('aria-busy', 'true');
              }
               
  
            }
            if (atcBtn) {
               atcText.style.opacity = "0";
            }
            const selectors = [
               'fieldset[data-not-included="true"] input',
               'fieldset[data-not-included="true"] select',
               'input[data-not-included="true"]',
               'select[data-not-included="true"]'
            ];
            const elementsToModify = document.querySelectorAll(selectors.join(','));
            elementsToModify.forEach(element => {
               element.removeAttribute('required');
            });
            const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
            submitButtons.forEach((submitButton) => {
               submitButton.setAttribute("disabled", "disabled");
               submitButton.setAttribute("aria-busy", "true");
            });
            document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"]').disabled = 'true'
            if (!form.checkValidity()) {
               form.reportValidity();
               submitButtons.forEach((submitButton) => {
                  submitButton.removeAttribute("disabled");
                  submitButton.removeAttribute("aria-busy");
               });
               //-console.log("validity error")
               if (loadingSpinner) {
                  loadingSpinner.classList.add('hidden');
               }
      
               if (atcBtn) {
                  atcText.style.opacity = "1";
               }

               //Jay commenting out due to after add to cart the form for some reason adds the 'required' attribtue to foodify options
               // elementsToModify.forEach(element => {
               //    element.setAttribute('required', '');
               // });
      
               return false;
            }
            return true;
            ///////////////////////////////////////////////////////////////
         }
         function afterAddtoCart(form) {
            ///////////////////////////////////////////////////////////////
            const selectors = [
               'fieldset[data-not-included="true"] input',
               'fieldset[data-not-included="true"] select',
               'input[data-not-included="true"]',
               'select[data-not-included="true"]'
            ];
            const elementsToModify = document.querySelectorAll(selectors.join(','));
            elementsToModify.forEach(element => {
               element.removeAttribute('required');
            });
            const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
            submitButtons.forEach((submitButton) => {
               submitButton.removeAttribute("disabled");
               submitButton.removeAttribute("aria-busy");
            });
            if (loadingSpinner) {
               loadingSpinner.classList.add('hidden');
            }
            if (atcBtn) {
               atcText.style.opacity = "1";
            }
           
            //Jay commenting out due to after add to cart the form for some reason adds the 'required' attribtue to foodify options
            // elementsToModify.forEach(element => {
            //    element.setAttribute('required', '');
            // });
            document.querySelectorAll('#product-options select, #product-options input[type=checkbox], #product-options input[type=radio]').forEach(element => {
            if (element.type === 'checkbox' || element.type === 'radio') {
              element.checked = false;
              element.setAttribute('data-last-clicked', 'false');
            } else {
              element.selectedIndex = 0;
            }
            element.dispatchEvent(new Event('change', { bubbles: true }));
          });
            ///////////////////////////////////////////////////////////////
         }
         ///////////////////////////////////////////////////////////////
       }

       function addToCartInitializerMultiple(){
         
         waitForElmFoodify(`${uniqueSelector} .update-button`).then(() => {
           ///////////////////////////////////////////////////////////////
           const updateButton = document.querySelector(`${uniqueSelector} .update-button`)
           const updateButtonText = updateButton.querySelector(`span`)
           
           if(isCollectionListingPage()) { updateButton.querySelector("span").textContent = 'Add To Cart'; }
              
           updateButton.addEventListener('click', function(event) {
               event.stopPropagation();
               event.preventDefault();
  
               window.variant_sku = updateButton.getAttribute('data-variant-sku');
               window.variant_title = updateButton.getAttribute('data-variant-title');
               let linekey = updateButton.getAttribute('data-update-line-key') || null;

               /*  console.log(requireLoginFoodify, !window.customerLoggedIn)  */

               if (requireLoginFoodify) if (!window.customerLoggedIn) { try { MicroModal.close(); document.querySelectorAll('.modal.is-open').forEach(el => el.classList.remove('is-open')); } catch (err) { console.error(err); } document.body.style.overflow = 'auto'; try { document.querySelector('#deliverify-main').style.pointerEvents = "none"; } catch (err) { console.error(err); } try { MicroModal.show('modal-login'); } catch (err) { console.error(err); } try { const submitButtons = Array.from(document.querySelectorAll(`${uniqueSelector} button[type="submit"]`)); submitButtons.forEach((submitButton) => { submitButton.removeAttribute("disabled"); submitButton.setAttribute("aria-busy", "false"); }); return; } catch (err) { console.error(err); } }
    

               /*  return  */
               /*  console.log("continue")  */
                                 
               window.currentUpdateButton = updateButton;
               updateButton.disabled = true;
               updateButton.setAttribute('aria-busy', 'true');
                          
               if(updateButton.querySelector('.loading__spinner')){ updateButton.querySelector('.loading__spinner').classList.remove('hidden'); }
               if(updateButton.querySelector('span')){ updateButton.querySelector('span').style.opacity = '0'; }                                          

               // return
               const price = getPrice(uniqueSelector);
               
               let form = undefined;
               if(isCollectionListingPage()) {
                 form = document.querySelector(`.product-card-info-area form[action="/cart/add"][is="product-form"]#product_form_${uniqueSelector.replace(".modal#modal-","")} `);
               }
               else {
                  form = document.querySelector(`${uniqueSelector} form[action="/cart/add"][data-type="add-to-cart-form"][is="product-form"]`);
               }
               const formData1 = new FormData(form);
             
               if(checkAnySelectedMultiple(form, uniqueSelector)){
                  const errorMessage = document.createElement('div');
                  errorMessage.classList.add('modal-error-x')
                  const buttons = form.querySelector('footer.modal__footer') || document.querySelector(`${uniqueSelector} footer.modal__footer`);
                  if (!buttons) return;
                  Object.assign(errorMessage.style, { color: 'red', marginTop: '-20px', paddingBottom: '10px', display: 'block' });
                  const parentOfButtons = buttons.parentNode;
                  parentOfButtons.insertBefore(errorMessage, buttons);
                  errorMessage.textContent = 'Please select an option.';
              
                  setTimeout(() => {
                    const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
                    submitButtons.forEach((submitButton) => {
                       submitButton.removeAttribute("disabled");
                       submitButton.removeAttribute("aria-busy");
                    });
                    updateButtonText.style.opacity = "1"
                    updateButton.removeAttribute("aria-busy");
                    updateButton.removeAttribute("disabled");
                  }, 500);
                  setTimeout(() => {
                    errorMessage.style.display = 'none'; 
                  }, 1500);
                  return
                }

               if (typeof window.validateFoodifyCustomWeight === 'function') {
                 const customWeightValidation = window.validateFoodifyCustomWeight(uniqueSelector);
                 if (!customWeightValidation.valid) {
                   const errorMessage = document.createElement('div');
                   errorMessage.classList.add('modal-error-x');
                   const buttons = form.querySelector('footer.modal__footer') || document.querySelector(`${uniqueSelector} footer.modal__footer`);
                   if (!buttons) return;
                   Object.assign(errorMessage.style, { color: 'red', marginTop: '-20px', paddingBottom: '10px', display: 'block' });
                   const parentOfButtons = buttons.parentNode;
                   parentOfButtons.insertBefore(errorMessage, buttons);
                   errorMessage.textContent = customWeightValidation.message || 'Enter a valid weight.';
                   setTimeout(() => {
                     const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
                     submitButtons.forEach((submitButton) => {
                       submitButton.removeAttribute("disabled");
                       submitButton.removeAttribute("aria-busy");
                     });
                     updateButtonText.style.opacity = "1";
                     updateButton.removeAttribute("aria-busy");
                     updateButton.removeAttribute("disabled");
                   }, 500);
                   setTimeout(() => {
                     errorMessage.style.display = 'none';
                   }, 1500);
                   return;
                 }
               }
             
               createSandwich(formData1, form, price, linekey)
             }); 
  
           async function createSandwich(formData1, form, price, linekey) {
             ///////////////////////////////////////////////////////////////
             // console.log("create sandwich"); console.log(form); console.log(form.querySelector('input[name="id"]').value); console.log(form.id.value);
             let variantID = form.querySelector('input[name="id"]').value;

             function getFormValues(form) {
              const inputs = form.querySelectorAll('input, select, textarea');
              const values = {};
              inputs.forEach(input => {
                if (input.type === "checkbox" || input.type === "radio") {
                  if (input.checked) {
                    values[input.name] = input.value;
                  }
                } else {
                  values[input.name] = input.value;
                }
              });
              return values;
            }
             if (typeof window.syncFoodifyCustomWeightUi === 'function') {
               window.syncFoodifyCustomWeightUi(uniqueSelector);
             }
             const formValues = getFormValues(form);
             mergeCustomWeightFormValues(formValues);

             // TEST: Skip Gadget API and add directly to cart with _price
             console.log("TEST MODE: Adding to cart with _price instead of Gadget API (multiple)");
  
             ///////////////////////////////////////////////////////////////
             // The item is already in the cart when this runs — show Added
             // now, close the modal right after, no staged waits.
             setTimeout(() => {
               setTimeout(() => {
                 updateButton.removeAttribute('aria-busy'); 
                 updateButtonText.style.opacity = '1'
                 updateButtonText.textContent = 'Added'
                 updateButtonText.style.setProperty('color', `${highlight_text_color}`, 'important');
                 updateButton.style.setProperty('background', `${highlight_bg_color}`, 'important');
                 document.body.style.overflow = "auto";
               }, '0')
               
               setTimeout(() => {
                 updateButton.disabled = false;
                 updateButtonText.textContent = 'Add To Cart'
                 if(useArrow) {
                   updateButtonText.style.setProperty('color', `${highlight_text_color}`, 'important');
                   updateButton.style.setProperty('background', `${highlight_bg_color}`, 'important');
                 }else {
                   updateButtonText.style.setProperty('color', `${normal_text_color}`, 'important');
                   updateButton.style.setProperty('background', `${normal_bg_color}`, 'important');
                 }
               }, '1400')
  
               setTimeout(() => { 
                 try{MicroModal.close(); document.querySelectorAll('.modal.is-open').forEach(el => el.classList.remove('is-open'));}catch(e){} 
                 document.body.style.overflow = 'auto';
                 try{document.querySelector('#deliverify-main').style.pointerEvents = "none"}catch(err){}
                 
                 setTimeout(() => { 
                   document.querySelectorAll(`${uniqueSelector} #product-options select, ${uniqueSelector}  #product-options input[type=checkbox], ${uniqueSelector}  #product-options input[type=radio]`).forEach(element => {
                    if (element.type === 'checkbox' || element.type === 'radio') {
                      element.checked = false;
                      element.setAttribute('data-last-clicked', 'false');
                    } 
                    else {
                      element.selectedIndex = 0;
                    }
                    element.dispatchEvent(new Event('change', { bubbles: true }));
                   });
                 }, '100')
               }, '900')
               
               afterAddtoCart(form);
              }, 0);
             ///////////////////////////////////////////////////////////////
        
             try {
                ///////////////////////////////////////////////////////////////
                // TEST: Add directly to cart with custom price
                const variantId = variantID;
                
                // Get quantity from form (default to 1 if not found)
                const quantity = parseInt(formValues.quantity) || 1;
                
                // Add cart item with custom price
                const cartItem = {
                  id: variantId,
                  quantity: quantity,
                  price: price, // The updateShopifyCart function will automatically add this as _price property
                  properties: {} // Initialize properties object
                };
                
                // Add all form properties to the cart item
                Object.keys(formValues).forEach(key => {
                  if (key !== 'id' && formValues[key]) {
                    cartItem.properties[key] = formValues[key];
                  }
                });
                
                console.log("Adding to cart with custom price (multiple):", cartItem);
                
                // Use the existing updateShopifyCart function with custom price
                updateShopifyCart([cartItem], formValues, form, linekey);
                
                form.setAttribute('data-form-ready', 'true');
                
                // COMMENTED OUT: Original Gadget API call
                /*
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                       'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload),
                 });
                const data = await response.json();
                const variantId = data.variantId;
                const originalVariantId = data.parentVariantId;
                form.querySelector('input[name="id"]').value = variantId;
                form.setAttribute('data-form-ready', 'true');
  
                // Jays new add to cart function -> found in simple-add-to-cart.js
                updateShopifyCart([{id: variantId, quantity: 1, price: price}], formValues, form, linekey);
                form.querySelector('input[name="id"]').value = originalVariantId;           
                */
                ///////////////////////////////////////////////////////////////
              } 
             catch (error) {
                 console.error('Error during cart add:', error);
                 afterAddtoCart(form)
              }
             ///////////////////////////////////////////////////////////////
           }

           function afterAddtoCart(form) {
              const selectors = [
                 'fieldset[data-not-included="true"] input',
                 'fieldset[data-not-included="true"] select',
                 'input[data-not-included="true"]',
                 'select[data-not-included="true"]'
              ];
              const elementsToModify = document.querySelectorAll(selectors.join(','));
              
              // Jay commenting out due to after add to cart the form for some reason adds the 'required' attribtue to foodify options
              // elementsToModify.forEach(element => {  element.removeAttribute('required');  });
        
              const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
        
              submitButtons.forEach((submitButton) => {
                 submitButton.removeAttribute("disabled");
                 submitButton.removeAttribute("aria-busy");
                 // console.log(submitButton)
                 const spanElement = submitButton.querySelector('span:not(.button__loader)');
                 if (spanElement) {spanElement.style.opacity = '1';}
              });        
           }
           ///////////////////////////////////////////////////////////////  
         });
       }
      
       if(!forMultiple){
         addToCartInitializer()
       }
       else {
         addToCartInitializerMultiple()
       } 
       ///////////////////////////////////////////////////////////////
  
    } //end foodify
